module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "ch1"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "page7"
    }
  })]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "part_no"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "part_title"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Paris")]), _vm._v(", "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("April — May 1944")])])]), _c('div', {
    staticClass: "pbk"
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('span', [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("Kevin jabbed his gleaming screwdriver into Emile’s eye socket as his fellow inmates pinned the terror-stricken victim down on the rough, wooden bench. Gleefully, he pried out the eye so it slid down the man’s forehead in a spurt of gore to plop on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The German Wehrmacht officer front row center fainted dead away.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Even as he groped in the synthetic “gore” contained in the little rubber pouch hidden behind Emile’s glass eye, Kevin grinned to himself with a glow of malicious satisfaction. When he’d forced Emile down on his back across the bench, the man’s screaming head hanging over the end of it mere feet from the footlights and the front row of the audience, he’d noticed the German blanch. And as Emile’s bloody eye plopped to the stage floor right in front of the man, he’d watched the Nazi officer go slack and slide down in his seat. Out cold.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The first-aid attendants who were always on duty during the performances at the Theatre du Grand Guignol hurried over to lift out the dead-to-the-world superman. Kevin noticed that one of them deliberately slammed the seat down on the major’s limp fingers. He smiled to himself, as with the insane ravings demanded by his role in the play he found the eye, a gruesome object, lying in the crimson slime on the stage floor. The German would have a damned sore hand when he woke up, and wonder how the hell he got it. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tant pis")]), _vm._v(" — too bad.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("The play was one of his favorites in the Grand Guignol repertoire. It took place in the ward of an asylum for the criminally insane somewhere around the turn of the century.")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v(" Kevin played a child molester who had been blinded in rage by the father of a little girl he had killed. He’d gone insane, constantly seeking a pair of eyes as blue as those of the dead little girl to use for himself. When the other inmates in the asylum tell him that a young newcomer has bright-blue eyes, the result is inevitable at the Grand Guignol, which specialized in performing one-act plays of horror and violence — the bloodier, the better. He loved the part. A real set-chewer. He had the blind bit down pat. And Emile, with his empty eye socket (which had kept him safe from conscription and which could hold a bright-blue glass eye), was made for the part of his victim. That climactic scene on the bench never failed to reap at least a couple of dead faints.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("As the curtain fell to the nervous applause of the audience, Kevin watched the limp German officer being carried away to the theater’s little infirmary in the back of the auditorium, where a nurse was always in attendance. The evening had been a four-fainter, according to his count. But then, anything less than two patrons in the audience passing out cold at any given performance was considered a failure by the company.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin peeked out at the emptying house through the dirt and grease-paint-ringed “house-counting peephole” in the curtain. He was always intrigued with the reaction of the audience. And its makeup. People from all walks of life and all ages came to the Grand Guignol — from sedate elderly matrons to wide-eyed sweet young things. And now, with Paris overrun by Nazi occupation troops, a great number of German officers and their mademoiselles. Even the Nazi big-shot Hermann Goering was a steady customer when he visited Paris. Kevin had often seen his fat bemedalled bulk sprawled in the front row. Horror and violence seemed to have a universal fascination.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("He worked the hole around to sweep the little auditorium. In row four, stage right, an elderly couple remained in their seats. It often happened. A few people would stay behind for a while, replenishing their drained")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v(" emotions, as it were, before braving the horrors and violence of the real world outside — a world torn by war and tortured by the subjugation of a brutal enemy.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("The woman was staring at the program notes while collecting herself; perhaps even reading them, Kevin thought. If she were, he knew what she would read about the Theatre du Grand Guignol. It was an engrossing story.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She would learn that the Grand Guignol was one of the most unusual and best-known theaters in all of Europe, despite the fact that it was the smallest house in Paris; a theater so tiny that anyone in the audience who budged while the curtain was up was in danger of becoming part of the gruesome acts on the stage. The auditorium had only 280 seats, a maximum capacity of 302 patrons with standees, which, happily, was often the case. Fittingly located at the end of a gloomy alley off Rue Chaptal in the Montmartre area, it had originally been a chapel, where during the early nineteenth century, the fiery Dominican preacher Henri Gabriel Didon thundered his hellfire-and-brimstone sermons. Shades of things to come, Kevin had always thought. From him the place passed into the hands of the French painter George Antoine Rochegrosse, who used it as his studio and is said to have painted his famous painting “The Rape of the Sabine Women” there. Again, quite in keeping with what was to come, when in 1896 the building became a theater.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("At first it was called Theatre Salon. It presented one-act plays in the new “realistic” style of the times, and it might well have stayed that way had it not been for one Edgar Allan Poe. Nearly six decades before, Poe had written a gothic story called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Tell-Tale Heart,")]), _vm._v(" which had been dramatized. It was presented at the little theater in 1901 — and the Theatre du Grand Guignol was born, its fate sealed.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("The theater prided itself on never closing its doors, performing plays seven days a week with matinees on Sundays, as was proudly pointed out in the program notes. The Grand Guignol had stayed open through depressions")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v(" and wars. In fact, Kevin knew of only once that it had been closed. It had been the day of the funeral of the World War I hero Marshal Ferdinand Foch, in 1929.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Of the thousand to fifteen hundred plays submitted to the theater each year, only some twenty new ones were chosen for production. The oldies always seemed to draw bigger audiences. In the lobby and at the box office, pictures and posters of past performances were displayed — "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Mark of the Beast,")]), _vm._v(" showing a leprous Hindu being horribly scorched with fire brands; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Horrible Experiment,")]), _vm._v(" with the proverbial mad scientist performing a bloody brain operation; and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lighthouse Keepers,")]), _vm._v(" picturing a father whose face and hands had been mutilated by ferocious bites strangling his son who is seized with the maniacal fury of rabies — all in glorious color.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Some of the most prominent French playwrights submitted plays to the Grand Guignol, and a few of them were listed in the program: Octave Mirabeau, Sacha Guitry, Guy de Maupassant, and Henri René Lenormand. Many of the leading actors and actresses in Paris had had their start at the Theatre du Grand Guignol, and illustrious stars from foreign lands had performed there. The incomparable British actress Dame Sybil Thorndike, for example, acted in a horror play called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Kill")]), _vm._v(" in 1921, and it is said she was magnificent. But the unique aspect of the Grand Guignol ensemble were the regular company actors. Because of the special kind of plays the theater put on, several of the actors had special “endowments,” as they chose to call them — a missing ear or eye like Emile, a missing limb, or other impairments. Such oddities were used to the fullest, most gruesome advantage.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("This, too, was true of the two touring companies mounted by the Theatre du Grand Guignol. One that travelled throughout France, performing the most popular plays from the repertoire; the other that visited foreign theaters. Kevin, himself, had often gone on tour to other countries.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('a', {
    attrs: {
      "id": "page13"
    }
  })]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("And there was more. Much more. Kevin knew it all. He had helped write the program notes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The woman in row four finally got up from her seat. She let the program fall to the floor and followed her impatient husband to the exit.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("In the back of the auditorium, the German major emerged from the infirmary looking dazed, nursing one of his hands. Shakily he made his way toward the door, steadying himself on the backs of the wooden church-pew-like theater seats. Uneasily his eyes roamed over the walls, paneled in old dark wood in a strangely forbidding combination of pseudo-gothic and baroque excesses. He seemed to shudder — and made a bee-line for the exit.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Couldn’t have been a Gestapo man, Kevin thought as he left the peephole, or that bit with Emile wouldn’t even have made him blink.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin took a quick look around. The stage was deserted, only a work light was burning. The company manager was at the box office counting the evening’s take, as he did every night, and the performers were in their dressing rooms, trying to get back to being normal.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He made his way to the stairs behind the pin rail that led down to the scenery and property docks under the stage and auditorium, the old chapel crypts.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The stairs leading down were worn and dark, the walls crisscrossed with scrapes by the set pieces carried up and down the narrow stairwell through the years. He turned on the light and started down. As he came to the basement level, he noted that the far end of the set storage area was in darkness. A bulb must have burned out, he thought idly. He peered across the angular shadows cast by the close scenery pieces toward the darkness beyond.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Suddenly his mind was flooded with the memory of the first time he’d gone down the stairs to the vaults below. It had been nine years before. A different, innocent time. Although he’d been sixteen years old, he’d just seen his first Grand Guignol horror play, and he’d clutched his father’s")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v(" arm, terrified at the forbidding place. Then, as now, the far bulb had been out. Then, as now, the looming, morguelike set pieces had stood leaning against one another at crazy angles, casting their jumble of sharp, jagged shadows across the docks like huge black knife blades.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("What if, he thought. What if . . . ?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It was a mental game he played with himself. What if Poe’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tell-Tale Heart")]), _vm._v(" had never been written? Would the Grand Guignol "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("be")]), _vm._v(" the Grand Guignol? Would it have survived as a theater at all? Or would it now be a bakery? Or a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("maison de rendezvous?")]), _vm._v(" . . .")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What if Corporal Adolf Hitler had been killed in World War I on a messenger run? Would there have been a Nazi party? A Third Reich? A World War II? . . .")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And now, as he stood staring into the gloom of the cellar storeroom, he thought: What if my father had not volunteered for the army in the First World War? Would I now be an actor at the Theatre du Grand Guignol? Would I even have been born? What if my father had not been a doughboy in World War I? What if . . . ?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But, he had . . . .")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Michael Alistair Lavette was a minor league actor in Greenwich Village theaters in New York City when the United States entered the war in 1917. He was sent to France with the American Expeditionary Force under General “Black Jack” Pershing; fought at Chateau-Thierry; lost his left arm just below the elbow at the second battle of the Marne; and fell in love with a Parisian girl named Genevieve Lescault, whom he married in 1918 as soon as the armistice was signed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin was born the next year.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Mike stayed in France, and the first few years of Kevin’s education took place in Paris before Mike decided to return to the States with his French wife and little son. And while Mike appeared in off-Broadway plays, his parts severely limited by his handicap, Kevin continued his education in New York.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("But when Kevin was in his first year of high school,")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v(" Mike and Genevieve were called back to Paris, where the parents of Genevieve lay dying after a disastrous accident in the Paris Metro. Kevin went with them.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("It took much longer than anticipated to clear up the estate of Genevieve’s parents, and Kevin entered the American School in Paris to finish his education.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Mike, looking for work, found out about the Theatre du Grand Guignol, and his acting experience and “special endowment” quickly earned him a firm place in the permanent company of actors.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The year was 1935. The Saarland was incorporated into Germany, and the Luftwaffe was formed. Two years later, Kevin’s mother succumbed to double pneumonia, and Kevin — having graduated from school — joined his father at the theater as a prop boy. He gradually advanced to assistant stage manager, stage manager, and to acting in bit parts. Because of his natural acting abilities, these minor parts soon turned into principal roles, and father and son often acted together, as in the revivals of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lighthouse Keepers,")]), _vm._v(" the gruesome play in which a hydrophobic son tears his father apart before being strangled to death by him. Both Mike and Kevin loved the histrionics of it all. And no two performances ever seemed to be quite the same. Michael loved to ad-lib, both in words and action, anything that came into his mind. Kevin was often awed, if not a little put out, at his father’s sometimes overenthusiastic impulsiveness. Though imaginative and possessed of a vigorously logical mind, Kevin tended to be more premeditative, more analytical, and less improvisational than his father. Somehow their different temperaments meshed perfectly, both on and off stage.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Yet Kevin was independent and prone to take charge. Someone at the Grand Guignol who was interested in things Oriental had once told him that 1919 — the year Kevin had been born — was the Chinese Year of the Ram. Curious, he had gone to the library and looked up what that meant. He’d learned that, according to Chinese lore, people born in the Year of the Ram tended to look to")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v(" others for guidance and were followers rather than leaders. He had been determined to prove the Chinese wrong. And he had . . . .")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin stood looking into the shadowy realm of make-believe.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It was all the result of his father’s enlisting in the army, he thought. All of it. What if . . . ?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He walked to the far area of the storage room, feeling the gloom enveloping him as with a tangible black cloak. He looked up at the dark bulb.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Dead? Or merely loose? He started to reach up to test it. Suddenly he stiffened in shock as he felt himself grabbed from behind by two powerful arms that held him in a bearhug grip, pinning his arms to his sides.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A hard, pointed object was jabbed into his back and a harsh voice rasped in his ear.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Ne bougez pas! Ne faites pas un bruit!")]), _vm._v(" — Don’t move! Do not make a sound!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The French was spoken with a heavy accent.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("“You’ve got the wrong man, dammit!” Kevin protested. He spoke in English. The unseen assailant’s accent had been unmistakably British. “My name is Lavette. Kevin Lavette. I’m an actor with the company here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Kevin")]), _vm._v(" Lavette, is it?” Switching to English, the voice hissed unpleasantly in his ear. “Try again, mate!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I don’t have to,” Kevin snapped angrily. “You heard me!” He tried to wriggle loose, in vain. “Get your damned hands off me!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But the iron grasp did not let up.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Look,” Kevin growled. “If you don’t believe me, touch my face. I just got off the stage. I’m still wearing my damned makeup.”")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("The tight hold did not slacken, but Kevin felt a finger")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v(" rub hard across his cheek. So, there were two of them, he thought.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Blimey!” another voice exclaimed. “He’s right. He’s got bloody goo all over his bloody face.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin felt himself being pushed away roughly. He stumbled against a papier-mâché-stone archway and caught himself. He whirled on his assailants.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There were two of them, one a bear of a man with a fierce moustache. Both were clad in an all too obvious mixture of ill-fitting civilian clothes and parts of the uniforms issued to British airmen. One of them held a double-edged paratrooper dagger dangerously leveled at Kevin’s gut.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“They told us to trust nobody,” the big man growled, “and we bloody well don’t.” He watched Kevin warily, the dagger steady in his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin knew the man was right, but he had been taken by surprise. He was angry. “What idiot told you that?” he lashed out at the Britisher.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The airman watched him, narrow-eyed. Instead of answering, he said: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Kevin")]), _vm._v(" Lavette, is it?” Suspicion darkened his voice. He glanced quickly at his companion, who was covering Kevin from a spot slightly to his right. “And, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Michael")]), _vm._v(" Lavette,” he said slowly, “who is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Michael")]), _vm._v(" Lavette?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I am!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The voice boomed through the large basement storage room as a man came striding toward them.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He was a good six feet tall and built like a track-and-field athlete, neither too skinny nor too muscle-bound. In fact, at forty-eight he looked like a younger leading man who’d had to daub his full dark hair with talcum powder and paint makeup lines around his eyes and across his forehead to look old enough for Act Three. The fact that his left arm was missing just below his elbow was not noticeable at all. The prosthesis was perfect, and the way Michael wore it and manipulated it appeared quite normal.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He stopped at the group. He glared at the big airman, still holding the dagger on Kevin.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("“I am Michael Lavette,” he said steadily. “What the hell")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v(" do you think you’re doing? Put that damned thing away!”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("The British airman stared at him. “You — you’re a bloody "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("man!”")]), _vm._v(" he exclaimed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What did you expect?” Mike snapped. “A gargoyle?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I thought — I thought when she said to mention "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Michael Lavette,")]), _vm._v(" it was — it was some sort of a password,” the airman stammered in confusion. He glanced at Kevin. “And that one, he got it wrong.” He rallied. “How the bleeding hell was I to know you were a man?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Well, you know now,” Mike said sourly. “And I think you’d better put that Kraut-skewer away.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The airman sheathed the dagger.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“How did you get "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("here?”")]), _vm._v(" Kevin asked. “Who told you to look for my father? Who’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("she?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The Britisher turned to him. He was again in full control of himself. “Your father, is it?” he grinned. “Sorry. But I couldn’t be certain of you. I didn’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Let’s have your story,” Mike said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’s a long one, chum, and not a very cheery one,” the moustachioed airman answered soberly, “and I’m not going to fag you out with the ruddy details of it. I am Flight Sergeant Higgins, RAF, Alfred Higgins.” Automatically, he drew himself up. He nodded toward his companion. “That’s Corporal Burt Henshaw, our tail gunner. We are the only survivors of a Lancaster crew. The other five went down with the plane. Never saw the bloody chutes.” He swallowed. “We were shot down near Chantilly, north of Paris, on our way back from a raid on Stuttgart. We had a rather dicey time of it. We were bloody well wrung out, so we kipped down in a barn and were doing the downey, when a bloke with a pitchfork poked us awake. He was a bit of all right, though. He gave us some clothes and fetched a mademoiselle he said could help us.” He grinned at Kevin. “That’s the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("she,")]), _vm._v(" chum. She concocted these bleeding get-ups.” He indicated the strange assortment of clothing worn by his companion and himself.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Did she tell you her name?” Kevin asked.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _c('a', {
    attrs: {
      "id": "page19"
    }
  })]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“She did,” Higgins answered. “Suzanne. A real smasher, she was.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“How did you get here?” Michael wanted to know.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We were piled into the back of an old lorry and deposited a few blocks from here, and —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Who drove the lorry?” Michael interrupted.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Not the foggiest, Guv’nor. Never saw him. Suzanne sat with him in the cab. She’s the only one we saw. Her and the farmer.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Michael frowned. “And she told you to come here and ask for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Not exactly like that. She told us to wait until the show was done and the crowd had left.” He shrugged. “We did. Last ones to come out was an old blighter and his missus and a Jerry officer who seemed all mops and brooms.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He had a sudden thought that obviously startled him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Gor blimey!” he exclaimed. “You do know the bird, don’t you, Guv?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We do,” Michael nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Good show,” Higgins said, relieved. “So, anyway, the girl told us to go in a side door, told us where it was, and say "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Michael Lavette")]), _vm._v(" to anyone we saw.” He frowned. “At least, that’s what I thought she said. Her English was about as good as my French.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Soberly, Michael contemplated the man, sizing him up.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Suzanne,” he said. “Did you get a good look at her?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Abso-blooming-lutely, Guv’nor,” the big flight sergeant grinned enthusiastically. “Who wouldn’t?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Then you must have seen the little mole on her cheek,” Michael continued. “On which cheek was it? Her right or her left?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The airman frowned. “Mole?” he said, puzzled. “On — on her cheek?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“If you got a good look at her,” Michael said, his voice suddenly cold, “you couldn’t have missed it.” Narrow-eyed, he glared at the man. “Which cheek?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Higgins stiffened. The air between them was suddenly tense.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _c('a', {
    attrs: {
      "id": "page20"
    }
  })]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“I — I don’t remember seeing a mole, Guv’nor,” he said slowly. “No mole.” He turned to the tail gunner. “Burt,” he asked, apprehension growing in his voice. “You see a — a mole on the bird?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The man shook his head. He looked frightened. “No, Alf. I didn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Higgins turned to Michael.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The girl we saw had no mole. At least we didn’t see any.” He stared at the grim Michael who stood facing him squarely. “No mole, Guv’nor,” he said firmly. “Perhaps — perhaps we are not talking about the same girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We are,” Michael said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He scowled at the two men. No one made a sound. Then Michael broke into a grin. “I’m glad you didn’t see a mole,” he said. “Suzanne has no mole.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The British flight sergeant looked blank. Suddenly he burst out laughing. “Lor’ lumme!” he exclaimed. “You had me going a yard and a half!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“As you said, chum, trust nobody,” Kevin pointed out dryly. He turned to his father. “Better get them out of sight. Choisy might be nosing around.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Right,” Michael agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Higgins looked at him questioningly. “Choisy? Isn’t her name on your poster out front? In big letters? Camille Choisy?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Michael nodded. “Yes,” he acknowledged, contempt in his voice. “But it’s a he, not a she. And he’s not part of our — our enterprise here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Doesn’t know about it,” Kevin added. “He’s the theater manager. Placed in that position by the Nazis when the former owner, Madame Berkson, had to leave Paris in a hurry when the Nazis came here.” He gave a crooked little smile. “She’d just put on a horror play to end them all. A real lulu. All about Nazi atrocities in Poland.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Choisy is a damned collaborator,” Michael spat. He reached up to tighten the light bulb.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Hope you don’t mind,” Higgins said, nodding at the bulb. “We thought you were a little too much in the limelight with that thing blazing down on us.”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _c('a', {
    attrs: {
      "id": "page21"
    }
  })]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’s okay.” Michael said. He started to walk toward the far end of the storage area. “Come on. We’ll take you to your home away from home.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The back area of the cluttered cellar held a collection of major props used in the plays. Replicas of monstrous medieval instruments of torture lined the stone walls. Like ghoulish harbingers of terror waiting to lumber to life, they loomed ominously in the shadowy space: a rusty witches’ dunking stool next to a branding brazier and a massive “iron boot”; a weathered pillory with a blood-soiled cat-o’-nine-tails and a set of thumb screws hanging from one of the holes; a guillotine, the slant-edged blade precariously poised above the half-moon-shaped neck rest stained and scarred, standing shoulder to shoulder with a hulking replica of an “Iron Maid,” her peaked medieval headdress framing a rigid, cruel face above a large ruffed collar. Hinges on the sides of the forbidding figure made it obvious that the front could be opened up.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("As the two British airmen eyed the chilling devices, Kevin grabbed hold of two heavy iron rings affixed to the front of the ferrous-looking cloak of the Iron Maid and pulled. With an appropriately creaking sound, the two halves swung open. The sharp points of the evil-looking spikes that studded the inside of the maid were discolored with brownish “fake” blood.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What the bleeding hell is that?” Higgins exclaimed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“She’s called the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eiserne Jungfrau")]), _vm._v(" — the Iron Maid of Nürnberg,” Kevin said cheerfully. “She’s kind of our patron saint down here. The original stands in the dungeon torture chamber of the Burg in Nürnberg.” He indicated the gruesome device. “The victims would be pushed inside her, and her embrace would impale them and slowly kill them.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Blimey!” the airman said softly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Here she does double duty,” Kevin went in, “in the play "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Secret of the Castle Dungeon")]), _vm._v(" and in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Inquisition.”")]), _vm._v(" He pulled the doors all the way open.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Higgins peered inside. He turned to Kevin. “After you!” he said.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page21"
    }
  }), _c('a', {
    attrs: {
      "id": "page22"
    }
  })]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin reached into the maid and took hold of a spike that was bent at a slight angle, one of several misaligned in that manner, probably attesting to the violence of the victims’ death throes. He pulled on it and the back opened up on a space beyond, so totally black that the darkness seemed to reach out to dim the light outside. Kevin reached in and flipped a switch.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The hidden room revealed beyond the maid was a fairly good-sized space. They all stepped through the opening in the device and through a hole in the wall behind.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You’ll be safe here,” Kevin said, “until we can pass you on.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The two Britishers looked around, obviously awed. The room held four cots — French army issue — a table and three chairs. In a corner stood an army chemical toilet; a folding screen with a Japanese motif stood leaning against the wall, and — incongruously — a sledgehammer stood leaning into the corner across from it. On the table were several tattered and dog-eared old English-language magazines; a deck of cards so worn that each card had a distinctive look of its own, defeating its very purpose; and a few English books. One of them was an Agatha Christie mystery. Kevin had meant to remove it. No use adding torture to the danger and discomfort — some fiend had torn out the last three pages. Despite a vent to the scene dock above, the air in the room was stale and sour.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“There are candles and matches in the table drawer,” Kevin told them, “in case you should need them. Go easy on them. They’re worth their weight in gold.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Higgins glanced at the burning light bulb hanging from the ceiling. “Ta’,” he said. “But you have electricity.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Sure we have,” Kevin said bitterly. “One hour a day, between eleven "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")]), _vm._v(" and midnight. The Germans take all our coal, and that’s all Paris can afford. The City of Light has become a city of darkness.” He shrugged. “We, that is the Grand Guignol, get extra power so we can put on our plays for the damned "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Boche.")]), _vm._v(" Courtesy of fat Goering, our number one fan.”")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("Higgins looked around the bleak place. “You did say")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("home")]), _vm._v(" away from home?” he said sardonically. “What "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" this place?”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“It was an old crypt,” Kevin answered. “It connected to the maze of underground tunnels that runs under Paris. But the access has long been bricked up.” He nodded toward the sledge-hammer. “In a pinch we can break through and escape that way.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Tunnels?” Higgins queried.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin nodded. “Almost two hundred miles of them. Abandoned rock quarries, some of them a thousand years old. Most of the stones used to build the city were quarried here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Blimey!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Some of the subterranean tunnels and galleries were once converted into catacombs,” Michael added. “They say six million Parisians lie down here, their bones stacked six feet high like kindling wood. Some damned famous ones to boot. Racine. Rabelais. Descartes. Pascal.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Blimey!” Higgins said again. It was obvious he’d never heard of any of Michael’s celebrities.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Right now the Resistance is using part of the tunnel network,” Kevin said. “To hide fugitives. As clandestine command centers and safe meeting places. The Germans can’t find their way around down there, so they don’t try too hard to find them.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Boche")]), _vm._v(" keeps pretty much to the sections around Invalides,” Mike added. “On the Left Bank. They’ve made the tunnels there into an air raid shelter for themselves, and they’ve got a telephone switchboard center down there. Their patrols rarely come up here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What happens to us now, mate?” Higgins asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You’ll stay here. We’ll bring you some food, get you some clothes from our wardrobe department, and —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I mean, where do we go from here? How do we get back?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“When the time comes, you will be escorted to the Pyrenees. To the Spanish border. From there you will be taken to Portugal. To Lisbon. And from there to England.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Good show! When?”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('a', {
    attrs: {
      "id": "page24"
    }
  })]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“First things first,” Michael said. “You’ll have to have proper identification. You’ll be on your own.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I thought you said we’d have an escort?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You will. We call it a detached escort.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Higgins looked blank.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It works like this,” Kevin explained. “Your escort will take a train to a town near the border, and transportation will be afforded you from there. He will, however, have no contact with you whatsoever. You will simply follow him and do exactly as he does. If you are caught, he will not interfere. He will not even know you. It is for the protection of all of us.” He looked soberly at the two airmen. “Escorts are hard to come by. Escapers are a dime a dozen. Those are the brutal facts.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Higgins nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We’ll get you the proper ID papers, though,” Kevin continued. “Only one thing is difficult.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Getting a photograph of the kind used on German permits. But we do have a way of getting them. There’s a photobooth at the Gare St. Lazare, a railroad station only a few blocks from here, that takes the exact same kind of picture you’ll need. You’ll have to go there and have your photo taken. Both of you. You will follow a detached escort, a girl. Her name is Gaby. She is one of us. You will do exactly as she does.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And if we are stopped?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You are on your own,” Kevin said gravely. “You will have to get out of any confrontation yourselves. We can do nothing.” He looked straight at Higgins. “And if you are taken away for questioning, Gaby will warn us. Because sooner or later, you will talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Higgins said nothing. It was obvious he did not agree. He looked around the room. “Quite an organization you have here, mate,” he observed.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("Kevin nodded. His mind leaped back to the beginning. It was August 11, 1942. He would never forget the day. The Gestapo had executed 99 hostages in retaliation for Resistance attacks on the Germans. One of them had been")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v(" his father’s best friend. They had decided then and there to fight the Nazi invaders until France was free once again. They "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" come a long way since. But a longer way lay ahead.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("He looked soberly at the two men.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Tomorrow, first thing,” he said, “we’ll find out if you’re up to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("It was a raw, cold April day when Gaby Kerouac walked down Rue D’Amsterdam toward Gare St. Lazare. Bundled-up Parisians huddled in small groups over the iron grills in the sidewalk to take advantage of the warm air rising from the Metro below. Fuel for heating was all but impossible to obtain in Paris in 1944, and cutting firewood from the trees in the city park — the only alternative — was severely punished. Even so, many ran the risk.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby drew her coat tighter around her. She glanced back. Her charge was following her faithfully, looking somewhat awkward in a large shop-worn overcoat from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fire and Ice")]), _vm._v(" wardrobe. Flight Sergeant Alfred Higgins was his name. RAF.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("She increased her pace. Partly to keep warm and partly because she wanted to get the trip over with. Acting as a detached escort was the duty she disliked the most. There was always the fear in her that she would be forced to abandon one of her helpless charges. Detached escort, she thought, a curiously paradoxical phrase. Certainly the furthest thing from her mind when she’d joined the company at the Grand Guignol as an actress five years — was it only five years ago? Paris had still been free, instead of cringing under the hob-nailed boots of the Nazis; submitting to having her homes arbitrarily searched; her citizens arrested;")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v(" her valuables looted and carted off; her young men abducted to labor as slaves in foreign lands; her fuel and food rations impossibly minute. There was a gallows-humor story going around that a Parisian’s meat ration was so small that it could be wrapped in a Metro ticket, provided the stub hadn’t been punched. If it had, the meat would fall through the hole. Funny — if it weren’t so close to the truth.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("She was coming to the station. She tried to avert her eyes from the huge garish swastika flags that hung prominently from the main building, as they did from all public buildings in Paris, in what she was certain was a deliberate affront to the Parisians.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Feeling both humiliated and defiant, she crossed the street at Place de Budapest, weaving her way through bicyclists and velotaxis, and making sure her charge was following her. She entered the station and headed straight for the three photo-automats in the waiting area.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Flight Sergeant Alfred Higgins watched the girl go up to one of the booths and disappear through the green curtain. He had enjoyed following her and watching her. She was a blooming looker, she was. He’d especially enjoyed the way her little firm ass moved as she walked. Those French birds had a way of wiggle-walking that would give any hot-blooded man a hard-on. When he saw her come out of the booth again and walk to a newsstand, he entered the booth and sat down in front of the camera.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The signs and instructions confronting him meant nothing to him, but he easily located the slot that would take the coin he had been given. All he had to do was put it in, sit still, and collect the strip of six photos as it was dispensed by the machine.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Automatically he wet his fingers on his tongue, slicked down his hair, and stroked his moustache. He reached toward the slot with his coin — and froze.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The camera had spoken to him. A low, urgent voice, heavily accented, had said:")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Be still, monsieur. I know you to be English!”")])])]), _c('p', [_c('a', {
    attrs: {
      "id": "page26"
    }
  }), _c('a', {
    attrs: {
      "id": "page27"
    }
  })]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("The thoughts exploded through Higgins’s mind.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He was caught!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The voice was not coming from the camera. It was coming from a crack in the partition to the adjoining booth. Someone was in there. Someone who had found him out. The enemy? The Gestapo? He had been betrayed. How? By whom? He was trapped. Trapped in a dirty, cramped little photo-booth. And they "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("knew")]), _vm._v(" who he was. When they questioned him, would he talk? As they had said he would? Or would he refuse? He did not know. He did not know. Would "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" betray his fellow crewman? Burt? And the Resistance members? The Lavettes? Gaby? . . . Gaby, who was waiting for him outside? He could not be sure. He would run. Lose his enemy in the crowds in the station. Make it on his own. The girl would be safe. He would —")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Listen on me, Englishman,”")]), _vm._v(" the voice hissed through the crack. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“You stay")]), _vm._v(" —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He leaped to his feet and threw himself through the green curtain out of the booth. He began to run. Away. Away from the girl. Away from the threat in the booth. He caught himself. Careful! Don’t run. Don’t call attention to yourself. Just walk. Fast.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He did. He did not look back. Not at the booth. Not at Gaby. He just walked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But the flesh on his back crawled. Any second he expected a cry to rise behind him and pursue him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Or a bullet rip through his borrowed coat into his back.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He kept walking.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby watched her charge rush from the photo-booth and rapidly walk away. She was startled. What was he doing? He was going the wrong way. Had he forgotten what he’d been told? In a moment he’d be out of her sight, lost. She started after him — and stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Another man came rushing from the photo-automat. A man in a belted overcoat and a soft-brimmed hat. She saw him hurry after the sergeant, catch up with him, and grab his arm.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("The chill of deep dismay coursed through her. Her")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v(" deepest fear had come true. The charge entrusted to her had been caught. She would have to abandon him. . . .")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Stricken, she watched the two men for a brief moment. She was about to walk away when she hesitated. Something was strange. Out of kilter. What? She stared at the men. The man who had accosted the big sergeant was talking to him insistently, but he didn’t seem authoritative but afraid. She frowned. The Gestapo? Afraid? The big Englishman was listening, obviously not understanding, looking for a way to break off the encounter and not finding it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby bit her lip in indecision. It would not be long before the two men would attract attention to themselves. The wrong kind of attention. Resolutely she began to walk toward them. She would have to interfere. She would have to try to help. Perhaps she could explain why the big man had no papers. Who he was. A foreign technician? An imbecile? Something. She was grasping for straws, and she knew it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She stopped. What she was about to do was totally against all the rules. Rules that were designed to save lives. Her clear duty was to return to the theater at once and report that her charge had been picked up. If, instead, she did go to the aid of the Englishman and was also detained, perhaps arrested, who would warn Kevin? And the others? She could not do it? She would have to leave the sergeant to fend for himself. He had not a chance in a million, but she had no choice.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Desolately she looked a last time toward the two men. The stranger seemed more insistent, the sergeant more desperate. The situation was coming to a head. She would "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("have")]), _vm._v(" to do something. She could not help herself. Anyway, if both she and her charge were arrested and neither of them came back to the theater, Kevin would know. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("That")]), _vm._v(" would be warning enough to take safety measures. She would try to help. She would try to persuade the accoster to let the sergeant go.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Deliberately she suppressed the certain knowledge that she had no chance of succeeding. No chance at all. . . .")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page28"
    }
  }), _c('a', {
    attrs: {
      "id": "page29"
    }
  })]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("She walked up to the two men. Higgins gave her a bleak look, but he said nothing. She ignored him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Bitte,”")]), _vm._v(" she said sweetly. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Darf ich helfen? Ich spreche Deutsch")]), _vm._v(" — May I help?"), _c('em', {
    staticClass: "italic"
  }), _vm._v(" I speak German.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Startled, the man turned to stare at her. Flustered, he answered her in French. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Je regrette.")]), _vm._v(" I—I do not speak German,” he stammered. “I am French. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Excusez moi.”")]), _vm._v(" Abruptly he turned to go.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby was momentarily taken aback. The stranger’s action had been completely contrary to anything she had expected. Her mind whirled. Who "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" he? What did he want? What was going on?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Monsieur!”")]), _vm._v(" she called. “Wait!” There was surprising authority in her voice.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The stranger stopped. He turned back to her. He looked frightened.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What — what did you want with this gentleman?” Gaby asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Nothing,” the man answered evasively. “It was — a mistake. I was mistaken.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Again he turned to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“He knows I am English!” Higgins suddenly whispered, just loud enough for the stranger to overhear. The man stopped dead in his tracks. He turned back to them, his face startled.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Monsieur,” Gaby said persuasively. “Please. Please stay. Who are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Nobody,” the man answered. “I am just —” He let the sentence die.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You think this gentleman is English?” Gaby nodded toward Higgins.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes.” It was barely audible.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The stranger looked up. “I — I was looking for an Englishman,” he said. His eyes searched Gaby’s. “You are from the Resistance, are you not?” he said. There was an unmistakable note of expectancy, of hope in his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Why are you looking for an Englishman?” Gaby asked, ignoring the man’s question.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page29"
    }
  }), _c('a', {
    attrs: {
      "id": "page30"
    }
  })]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Because — I need to establish contact with the Resistance,” the man explained. He seemed surprised at his own audacity. He looked searchingly at Gaby. “Are you?” he asked again. “Are you from the Resistance?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Again Gaby ignored his question. “Perhaps you had better tell us why you want to make contact with the Underground, monsieur,” Gaby said quietly. “Why are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("For a moment the stranger studied her face, his head slightly cocked to one side. He seemed to make up his mind. He took a deep breath.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I am a farmer, mademoiselle,” he said. “I have a farm near Meaux on the Marne, about thirty kilometers east of here.” He sounded on edge.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I know Meaux,” Gaby said pleasantly. It was not an earth-shaking piece of information, but she thought it would help put the man at ease.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The stranger nodded. “Many do.” He paused. “We — we have a crisis.” The words suddenly poured out. “There is a young woman. She has been grievously hurt, mademoiselle. Shot. By the Germans — the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sale Boche")]), _vm._v("! She is hiding on my farm. She is a — a spy, she says, an intelligence agent. From England. She was dropped by a parachute. She says she has vital information. Information that is of the gravest importance to France. It must get back to England. But she has no way. Her radio was lost. You see?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby nodded. “I understand. You want the Resistance to make contact with London for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes!” the man exclaimed. “That is it exactly!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby frowned. “But — what were you doing in the photo-automat?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I was looking for an Englishman.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Looking for an Englishman?” Gaby was puzzled.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("“Of course. I have friends, mademoiselle,” the farmer said proudly. “I tried to learn how to find the Resistance, but it was not allowed me. I — I asked around. I learned only this. That photographs for permit papers were often taken at public photo-automats because they are like the")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v(" ones the Germans use. On their papers. So, I thought, here, at the station, there is a photo-automat. And here, if I wait long enough, I will find an Englishman having his photograph taken.” He looked at Higgins. “Like monsieur, who looks most English to me.” He smiled. “And I would have him take me to the Resistance. I have been here two days. You see?”")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" Resistance!” the man said eagerly. “I am certain. You will help, will you not? It is of great importance. The woman "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("— l’espion —")]), _vm._v(" she is dying.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gravely Gaby contemplated the man. His beard stubble could easily be two days old. His manner could easily be that of a farmer. But his clothes — that belted coat — were not.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Monsieur,” she said. “Your coat. It is a city coat. Not a farmer’s coat. Where did you get it?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The man’s face grew solemn. “It was my son’s,” he said quietly. “He worked in the city. Here, in a big store — Le Printemps. He was killed by the Germans. At Abbeville. Four years ago. It is for him I do this.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I can do nothing for you, monsieur,” Gaby said softly. “But I may know someone who can.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The farmer regarded her expectantly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You will wait here,” Gaby went on. She pointed to a row of wooden benches in the waiting area. “Sit there,” she instructed him. “On the bench farthest to the left. Read a newspaper. I will send someone to contact you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Merci, mademoiselle,” the farmer beamed. He grasped her hand. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Merci mille fois! —")]), _vm._v(" Thank you a thousand times! I shall do exactly as you say.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby turned to Higgins. “Sergeant,” she said. “Go get your picture taken. Then follow me back. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin and Gaby stopped at a spot near the photo-booths from where they could observe the benches in the waiting area. A"), _c('em', {
    staticClass: "italic"
  }), _vm._v(" man sat at the far left, apparently engrossed in a newspaper.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("“That the man?” Kevin asked. His tone of voice came")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v(" out harsher than he had intended. He was still disturbed. Gaby had placed them all in jeopardy. The whole thing could have been a trap set for her. It still could be. It still could be a trap to catch more than just one escaping Englishman and his escort. It could still be a trap to catch the whole Resistance ring. Dammit! He was angry, but he realized that his anger was really his reaction to Gaby’s having placed herself in danger. He touched her arm.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Stay here,” he said softly. “Watch. If things go wrong, get back to my father. At once.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby nodded earnestly. “I will.” She looked up at him. “Be careful, cheri,” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He turned and walked toward the benches in the waiting area.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He stopped in front of the man whose face was hidden behind his newspaper. The man did not see him. Suddenly Kevin slapped the paper sharply with his hand. Startled, the reader dropped it and stared up at the man towering over him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin whipped a little leather folder from his pocket. He flipped it open, briefly exposing an identity card.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Gestapo!” he barked. “Your papers!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Apprehensively the farmer groped around in his pockets. Finally he came up with his ID. Kevin snatched it impatiently from his hand. Frowning, he studied it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You are François Marot?” he asked, his face grim.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Is this your current address?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Is it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Meaux,” Kevin snapped. “What are you doing here?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Life must go on, monsieur,” the farmer shrugged. “There are things to be had in Paris that are not to be had in Meaux.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Why are you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("here?")]), _vm._v(" At this station? The trains for Meaux depart from Gare de L’Est. Not from here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Ah, monsieur, I am here because of the photo-automats.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“There are photo-automats at Gare de L’Est.”")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("“Out of order, monsieur,” Marot shrugged regretfully.")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v(" “All of them, more’s the pity. And no one to fix them.”")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“What do you want with the photo-automats?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“To take my picture,” Marot answered ingenuously.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“My daughter,” the farmer explained patiently. “She lives in Epinac. Perhaps you have heard of it? lt is beautiful in the mountains there. She wanted a photograph of me to show.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Let me see it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Again the farmer shrugged. “It is confusing,” he said. “There are many instructions in the booth. They must be studied carefully.” He ran his hand over the stubble on his chin. “I do not have such a photograph yet, monsieur. I must get my face cleaned up before I put my money in the machine to get my photograph.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Then why are you sitting there?” Kevin asked sharply.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I am waiting, monsieur.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“For what?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“For the barber. He was busy. I saw it through the window. In a few minutes I will go there again, and he will give me a fine shave.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin studied the man. What the hell else could he ask him? The fellow had answers, and damned sly ones at that, for everything he could throw at him. His gut feeling was that the man was what he said he was. A farmer. If he had been a Gestapo plant, he would probably have identified himself by now. He made up his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The woman hiding on your farm,” he said quietly. “How badly is she hurt? Will she still be alive?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The farmer stared open-mouthed at him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“But you . . . you . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I am the one you have been looking for,” Kevin said quickly. “Just listen, and do what I tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The farmer gulped, and listened.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“There is a train for Reims in forty minutes. From Gare de L’Est. It stops in Meaux. Go there. Get on it. We will be on it with you, but you will make no sign that you know us. Do you understand?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Again the farmer nodded.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page33"
    }
  }), _c('a', {
    attrs: {
      "id": "page34"
    }
  })]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin turned and walked away. He had just placed himself, and Gaby, in the hands of a stranger.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He hoped to God it had been the right thing to do.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The answer was to be found on a farm near Meaux. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("Kevin was grateful that it was a cold, overcast day as they trudged past the dunghill piled up in a corner of the Marot farmyard. He knew the overpowering stench such manure heaps could produce on a warm day with the sun beating down on them. As a young man, he’d often lent a hand on a farm for a few days to make a little money when he’d been on bicycle tours through France, the Netherlands, and Germany during his summer vacations, usually with a friend, earning their way as they went. In fact, they prided themselves in coming back home with a little more money than they’d set out with. They’d clean barns, paint, do a little simple carpentry, even turn a dunghill or two — anything that needed doing. And they’d collected eggs the hens had been laying in favorite spots all over the farm. Sometimes hundreds of them, some of them so big there were only ten to a dozen. He still remembered that in the summer of 1936, he’d watched a German farmer’s wife put the eggs into storage in large barrels filled with water glass — a viscous, syrupy liquid that would preserve them — and with some astonishment had heard her say: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("One for us")]), _vm._v(" (as she put one egg in one of the barrels), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("two for the war")]), _vm._v(" (as she put two in the other). That had been in 1936. He’d learned a lot on those bicycle trips: about people, their land, and their customs, including an excellent knowledge of the German language.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("Marot’s farmhand, a sour-looking fellow named Gaspar, had picked them up at the railroad station with an uncomfortably")]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v(" hard-riding wagon. He was now leading the way with Marot toward a dilapidated barn.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Gray daylight seeped into the barn through a crisscross of cracks, daubing a spider’s web of drab light-streaks across dusty-dry bales of hay, empty stalls, a couple of broken wagons, and an old canvas-covered truck without wheels that was propped up on heavy pieces of lumber.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Marot walked up to the truck and threw the canvas backing aside. A woman, lying in the gloom inside, resting on a stack of sacking and covered with a quilt of many once-bright colors, stirred, and with a gasp of pain rose on one elbow in apparent alarm as Marot climbed into the truck, followed by Kevin and Gaby.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We could not keep her in the house,” the farmer mumbled, a touch of guilt in his voice. “Neighbors can have prying eyes and loose tongues, no?” He stood aside as Kevin and Gaby squeezed past him and knelt beside the woman. Marot lit a sooty kerosene lamp hanging from a canvas strut.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It was impossible to tell the wounded woman’s age. Her pale and drawn face was marred by deep scratches in which the blood had congealed in blackish welts. A blood-soaked bandage had inexpertly been placed on her temple over her left ear. Her lips were torn, and the caked blood that had trickled from the corners of her mouth gave her the exaggerated, grotesque appearance of the classic drama mask of tragedy. Her eyes, sunken deep in darkened sockets, stared at them in luminous terror.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Don’t be afraid,” Gaby said. “We are friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The woman stared at her. The mad luminosity did not leave her eyes. Close up, Gaby could see she could be no older than her middle twenties. The girl tried to scramble away from her. She let out a sharp cry and fell back on her crude bedding. “Millipedes!” she rasped in delirious terror, staring unseeing into space. “An army. An army of millipedes . . . millipedes. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin and Gaby exchanged glances. The girl was obviously raving. Gaby placed her hand on the girl’s sweat-glistening forehead. The girl seemed not to notice.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page35"
    }
  }), _c('a', {
    attrs: {
      "id": "page36"
    }
  })]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“She’s burning up,” Gaby said, deeply concerned.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“She has been shot,” Marot said under his breath. “Once in the belly. Once in the thigh. The right one.” He shook his head slowly. “She has lost much blood. Her insides are torn. She will not last the day.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Have you sent for a doctor?” Gaby asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Marot shook his head. “A doctor would have to come from Meaux,” he explained. “I know no doctor in Meaux. How could I trust anyone?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The girl groaned. She looked up at Kevin and Gaby bending over her. The madness had gone from her eyes, leaving only agony. It was as if the pain had torn her back to lucidity.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Who . . . who are you?” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Friends,” Kevin said. “We are here to help you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The girl shook her head. “Too late,” she breathed. “Not me. You must —” She stopped. She closed her eyes tightly as a wave of pain swept over her. When she opened them again, they sought Marot.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The farmer nodded gravely. “They can be trusted, mademoiselle,” he assured her. “They are from the Resistance. Of that I am certain.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And I,” the girl whispered. “How can "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I")]), _vm._v(" be certain?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby bent down to her. She nodded toward Marot. “This man,” she said earnestly. “This man who has helped you. This man who is sheltering you at his own peril. Do you trust him?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Slowly the girl nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“He trusts us,” Gaby said. “He has placed his life in our hands. Would he do that if he thought us his enemies?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The girl closed her eyes as another spasm of pain racked her. Then she looked up at Kevin and Gaby.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I am Nicole,” she whispered. “I am . . . the only one alive.” She winced in pain. “From a . . . a Jedburgh team. From England. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin looked puzzled. “Jedburgh?” he asked.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("“Not important,” sighed Nicole. “You must . . . must contact London. It is of the greatest importance. Tell them — "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rebus")]), _vm._v(" . . . understand? . . . "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rebus")]), _vm._v(" — has been")]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v(" aborted. Entire team killed.” Anxiously she tried to sit up, but the pain defeated her. “Do you understand?” she whispered urgently. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Rebus")]), _vm._v(" is no longer — operative. . . .”")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“We understand, Nicole,” Kevin said. “We’ll get you help. We’ll —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No!” Nicole exclaimed. “London. You must contact London. Tell them — "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mimoyecques")]), _vm._v(" is impossible to penetrate. Remember "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mimoyecques.")]), _vm._v(" Tell them —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Nicole,” Kevin interrupted her. His voice was firm, yet soft. “We will help. We will carry out any instructions you give us. But, to be of the greatest help, we must know what we are doing. We cannot work in the dark.” He paused. He looked gravely at the girl. “Tell us what you can of your mission, why you were sent here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("For a moment Nicole was silent, her feverish, pain-filled eyes locked on Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Rebus,”")]), _vm._v(" she whispered. “It was our code name. We were four. We were dropped near Saint Omer. South of Calais. Three days ago. On a mission of . . . of . . .” She shuddered violently as a wave of pain knifed through her tortured body. Her eyes rolled back in her head, and apparently slipping into incoherence, she mumbled, “Millipedes . . . millipedes. . . .” She began to moan, a sound that wrenched their souls.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Monsieur,” Gaby said crisply to Marot. “Water. I need a pail of cold water. And a cloth. Please hurry.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Marot nodded. “Gaspar!” he called as he jumped from the truck.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby turned back to Nicole. “Give me your handkerchief,” she said to Kevin. He did. She wiped the sweat from Nicole’s face as the girl tossed on her sackcloth bedding.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Presently Marot returned with a pail of water and an old piece of toweling. Gaby bathed the semiconscious girl’s forehead. She opened her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It is all right,” Gaby said soothingly. “You are with friends.” Feebly Nicole nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What did you find at — at Saint Omer?” Kevin asked. “What were you looking for? What happened?”")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("“Mimoyecques,” Nicole breathed, almost inaudibly.")]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v(" “The site is impenetrable. No one can get near it. German soldiers everywhere. The Fifteenth Army. Tell London.” She reached an imploring hand toward Kevin.")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin took it and held it. He nodded. “Mimoyecques.” He asked, “What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“A village,” Nicole answered. “A little village, southwest of Calais. But . . . but. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What happened?” Gaby asked gently.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It is a huge construction site,” Nicole whispered. “There is something being built there. Something greatly important, greatly secret. There are . . . thousands of workers. They labor day and night. But . . . no one knows on what. No one knows what it is. . . . The locals think it is a secret ray to stop airplanes in flight. Photo Intelligence cannot find an answer. Only on one mission did they obtain a few aerial photographs. Only a few. Because of the heavy camouflage. And the many antiaircraft guns. It . . . it looked like, like a huge iron millipede hundreds of feet long! A . . . a gigantic round body with many, many iron legs creeping up a hillside like an enormous iron millipede . . .” She stopped, exhausted by her long speech.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin frowned. “An iron millipede? Hundreds of feet long?” he said incredulously.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("Nicole nodded wearily. “I know what you think,” she whispered. “That I am . . . that I am out of my head.” Her pain-ridden eyes flashed. “But I am not! Not now. It is true. There are many of them being built. And security is stricter there than anywhere else. What they are building is of the greatest importance to them. And therefore to us.” She paused, her face contorted in pain. “That is why we were sent . . . but . . . we failed,” she went on, her voice growing ever weaker. “We were discovered. My comrades — Larry, Claude, Jean. Killed. Our equipment — the radio — lost. I . . . I got away. Because the others covered for me. I headed for Paris. I knew there was an Underground Railroad there. We had been told in our briefing. And I thought, I thought I could get out. Back to")]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v(" England. But . . . the Germans discovered me. I was shot. And . . . and. . . .” Her voice faded away.")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin and Gaby looked at one another bleakly. They knew there was nothing they could do for the girl.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Nicole,” Gaby asked gently. “Is there anything else you want us to tell London?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Slowly, with an obvious effort, Nicole looked up at them. “We . . . we were sent to find out what . . . what they were. The millipedes. What purpose they have . . . and now,” she breathed with evident difficulty, “now it is . . . too late. Too late to mount another mission. In time.” Desperately, she tried to rally her ebbing strength. “But . . . tell London . . . the answer cannot be had at Mimoyecques. At . . . at another place. We . . . learned that much. . . .” Her eyes closed. Her breathing became labored and shallow.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Where?” Kevin asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“On an island,” Nicole whispered, her voice growing rapidly weaker. “A little island. In the Baltic Sea. Called Wollin.” Her labored speech came in short staccato sentences. “Just north of Stettin. The German seaport. At . . . at Misdroy.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Suddenly she curled up in agony. Her breath was expelled from her in a sharp cry. She arched her back in convulsive pain — and went slack.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“An . . . iron . . . millipede,” she breathed, “at Misdroy. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They were her last words.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("For a long moment Kevin looked down at the girl, at her lacerated face finally at rest. At the blood-soaked bandage on her head. It is real, he thought. Real blood. Not the fake Grand Guignol formula. Real . . . .")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Somehow it looked different.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gently he pulled the old soiled quilt up over the girl’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Marot turned the kerosene lamp down and blew it out.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("“We will bury her,” he said gruffly. “Here, on the farm")]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v(" of François Marot. And when the war is won and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Boche")]), _vm._v(" has left, we will honor her.”")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("As they walked from the barn toward the wagon in which Gaspar would take them back to Meaux and the railroad station, Gaby looked at Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Misdroy,” she said quietly. “She said Misdroy. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She moved closer to him and took his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin nodded. “I remember, cheri,” he said. “I remember. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It had been long ago. Four? Five years? Gaby had just joined the Grand Guignol company, and he had fallen for her from day one. She had gone with them on a tour of Germany that year — her first. They had been playing a three-week stand at the Schauspielhaus in the German seaport of Stettin. It had been 1939.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Their engagement had followed that of another Paris-based theatrical company, The English Players from Theatre de L’Oeuvre. They also toured Europe, performing their plays in English: George Bernard Shaw, Somerset Maugham, and Oscar Wilde — their witty sophistication a far cry from the horror plays of the Grand Guignol. The two companies often leapfrogged the same cities, the same theaters. And Kevin exchanged tips and pointers on the local stages with the stage manager of The English Players whenever they met on the road. A fact that often prevented unforeseen problems that otherwise might have cut into his limited time.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("On their free days he and Gaby had taken trips through the countryside in a borrowed car — and they’d discovered the little island of Wollin and the charming village of Misdroy on the beach of the Baltic Sea. It had become a favorite spot. And it was there that he and Gaby, late one afternoon in a little secluded field newly mown, with the sun setting in a blaze of golden red, had made love for the first time.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("He still remembered her intoxicating scent mingled with the fragrance of fresh-cut grass. He still remembered the excitement, the passion, when for the first time they joined as man and woman. He still remembered the trembling")]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v(" desire when he held her soft, silken body close to his — and the rapture at the culmination of their love. The first time . . . At Misdroy.")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("And they had been there on September 1st, when Hitler’s hordes invaded Poland, and the war began.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He remembered how the little company of French actors and actresses, who soon would find themselves enemy aliens in a hostile land, had opted to split up in order for each one to get back to France before war was declared, rather than staying together as a company, with the attending prominence that entailed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And he remembered how he and Gaby, together, had set out to reach France before it was too late. At the time he had been surprised at the force of his need to get home. It had been more than simply reaching safety. With dangers dodging him, he had suddenly become aware of a strong attachment to the place where he had been born. Paris. And an overwhelming desire to return there. It was, he thought, a primeval vestige, an emotional or evolutionary appendix, much as the urge of so many wild creatures who return to the same place to spawn where they, themselves, were spawned. Seal and salmon. Turtles and birds.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And man?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They’d made it, he and Gaby. They nearly all had. Only one young man failed to return. They never knew what happened to him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Misdroy. He would never forget the place.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Would the little sleepy village once again play a decisive role in his life?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He had an unsettling feeling it would.")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("As dismal as the overcast day was on the farm of François Marot, as beautiful it was at Misdroy on the Baltic island of Wollin. A clear blue sky flecked with a few high, fleecy clouds arched over the lush countryside, and there was the promise of a glorious spring in the air.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("High above the ground, on the platform of Guard Tower No.2 at the main gate to the inner test site, SS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Standartenführer")]), _vm._v(" Dieter Haupt stood surveying through his")]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_vm._v(" field binoculars the gigantic test compound constructed for his Operation Busy Lizzie.")])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("He felt proud of what he had accomplished; confident that he would succeed in his ultimate goal. Tomorrow was the day. Tomorrow, full-scale trials and tests would begin. Tomorrow, his Busy Lizzie, jokingly daubed the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tausendfüssler")]), _vm._v(" — the millipede — by the technicians who worked on her, would finally come into her own.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Reichsminister")]), _vm._v(" Speer had been true to his word. He had to give him that. When he, Dieter Haupt, had returned to him with the final plans, Speer had personally approached the Führer, who immediately had seen and understood the tremendous possibilities of the audacious weapon. He had ordered work to begin at once on the further development of it and on the construction of operational sites. An area around the little French village of Mimoyecques on the Channel Coast had been selected. And Speer had, as promised, been instrumental in seeing to it that he, Dieter Haupt, had been placed in command of the entire project.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It had been a grueling two years. Two years and three months. Even before all the remaining design problems had been resolved, construction of a preliminary prototype of Lizzie — on a considerably smaller scale than the final weapon would be — had been undertaken. The initial trials of this Mini-Lizzie at Hillersleben had been successful enough to proceed with the project full speed. But because of the geographic location of the testing grounds at Hillersleben in the middle of Germany, only twenty kilometers from Magdeburg, a test site of far greater capacity had had to be found.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He had selected Misdroy.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Located on an island on the Baltic coast, it was out of the way, difficult to get to, easy to isolate, and had the entire Baltic Sea as a range. It had been the ideal answer.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_vm._v("The village of Misdroy was now a ghost town. It had been swallowed up by the Busy Lizzie test site, and its inhabitants spit out to work for the war effort elsewhere.")]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_vm._v(" Construction of the site itself and the full-scale prototype of Lizzie had progressed amazingly well and amazingly fast. Once again, Speer had come through, and a considerable foreign labor force had been made available for the project. Supplies had been on a top-priority basis, and worker deaths had been minimal, less than 12 percent. Haupt contributed that fact to his own efficiency.")])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("And now — all was ready. Slowly he surveyed the huge compound. It had been brilliantly laid out. It consisted of three separate areas. The inner super-sensitive actual test site where the Lizzie — or the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tausendfüssler —")]), _vm._v(" prototype had been built bordered on the sea, which was constantly patrolled by gunboats, and it was surrounded on the land side by a double barrier of barbed wire under continuous observation by watchtowers and patrolled by SS guards with dogs. It was his own design. He’d gotten the idea when he visited Auschwitz, one of the more efficient concentration camps. After all, what can keep people in can keep them out as well.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The inner site was surrounded by a secondary area where all supporting activities took place. There were machine shops, laboratories, guards’ quarters, and the like; and finally there was an outer area, again separated from the security areas with barbed-wire fences, where the housing for the labor force had been built, as well as their eating, sanitary, and hospital facilities. All most efficient.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Tomorrow, Haupt thought with prideful satisfaction, tomorrow the final test phase would begin. In another few months, if all went well — and it would — England would be brought to her knees. The installations at Mimoyecques were progressing rapidly and were nearly finished. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Alles war in Ordnung!")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Meanwhile, the newly completed vengeance weapon — the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kirshkern,")]), _vm._v(" an unmanned flying bomb the Führer had named the V-1, and other such possible weapons on the drawing boards — would soften up the Engländer for the knockout punch to be delivered by his Lizzie.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page43"
    }
  }), _c('a', {
    attrs: {
      "id": "page44"
    }
  })]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("She would finish the job and bring undisputed victory to the Führer and the Third Reich.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It was only a matter of time.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Nothing could stop his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tausendfüssler —")]), _vm._v(" his iron millipede — now. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("“There you go again,” Kevin snapped heatedly at his father. “Jumping in, both heads first. No thought for any rocks that may lie beneath the surface.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What rocks?” Mike asked huffly. “The way you tell it, it’s a piece of cake.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I didn’t say that, Dad,” Kevin protested with exaggerated patience. “I said it would be possible. Quite possible. For us.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And not for me?” Mike grumbled testily. “I can still take you over my knee, sonny-boy, and give you a good whaling!” He held out his arm on which he’d placed his special prosthesis. “Give me a hand with the straps,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin got up from his stool in front of the mirror in the little dressing room he shared with his father. He’d only applied his greasepaint base, a Leichner No. 2 Spot-Lite Klear, and looked strangely like an unfinished wax figure, even with a frown of exasperation on his face. He began to strap the prosthesis to his father’s stump. As usual for this particular role, it felt heavy — filled as it was with fresh red horsemeat packed around part of a shank bone and little balloons full of the special Grand Guignol blood. The theater had had to get a special ration for that meat, even though it was mostly inedible waste.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_vm._v("Father and son were getting ready for a play called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lumberman’s Revenge,")]), _vm._v(" which climaxed with Mike’s arm,")]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_vm._v(" held in a vise, slowly being sawed off by a buzz saw, with all the appropriate shrieks and screams and bloody chunks of meat and bone splinters spewing into the air. Very effective. Good for at least three faints.")])]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“You might,” Kevin commented dryly, “on a good day. But you might have a little trouble with the whole damned Nazi mob.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And you and Gaby won’t?” Mike asked archly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Okay, Dad,” Kevin said. “Let’s go over it again.” He yanked one of the straps tight. “We know that a team of Allied agents sent out from London on a secret mission has been wiped out. We know that the information they were after is of vital importance to the Allies, and that there is not enough time for London to put together another special operation to get that information. We also know that it isn’t possible to get near the place where they thought the information could be found. At Mimoyecques. The German Fifteenth Army is swarming all over the place. But it might be possible to find the information at Misdroy. Misdroy, Dad. Remember? The place Gaby and I were when the war broke out?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Of course I remember,” Mike growled. “I’m not senile yet.” He yanked the arm with the prosthesis away from Kevin, testing it. Kevin ignored the remark. “Misdroy,” he pressed on. “Gaby and I know that place. And we know our way around. We both speak German; well enough to pass for foreign workers or something.” He looked earnestly at his father. “Don’t you see? We could make our way to Misdroy. That should not be too difficult. And we might be able to learn whatever it is London needs to know. And there’d be no time problem. We could start out right away. No need to put together a whole new team and all that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I agree with you,” Michael said. “All the way. If there is half a chance to screw the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Boche")]), _vm._v(" and get information that is vital to the Allies, go to it, you and Gaby. Fine. I’ll help set it up.” A note of obstinacy crept into his voice. “There’s only one condition: I go along!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“But, Dad —”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page45"
    }
  }), _c('a', {
    attrs: {
      "id": "page46"
    }
  })]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“I speak German, too,” Mike said stubbornly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yeah. With a Bavarian accent so thick you can cut it with a sausage.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Can I help it if Hansi was from Bavaria?” Mike said defensively. “Bavarians are Germans, too. Or hadn’t you heard?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin frowned. Hansi had been a stagehand at the theater for about a year. He and Mike had spent the long hours backstage teaching each other their native tongues. Hansi had stamped his distinctive Bavarian dialect indelibly on Mike, teaching him his language, Including a string of swear words that would make a boiled lobster blush.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("For a moment, father and son glared at one another. Then Kevin broke into a smile of surrender. He knew that tone of finality in his father’s voice. “Okay, Dad,” he grinned. “The three of us it is.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Michael brightened at once. He began to shrug into a colorful woodman’s shirt that covered his prosthesis. “Now you’re talking, my boy!” he beamed. “We’ll play out the performance tonight, and tomorrow we’ll be off.” He waved his prosthesis triumphantly in front of him, “Rather than play-act for the damned "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Boche")]), _vm._v(" here for a few sous, I’d like to strut my hour on their home ground for a lot higher stakes!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Hold it,” Kevin laughed. “Not so fast. There are a lot of things we’ve got to do first.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Such as?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Well, first of all we have to make contact with London. Tell them what’s happened and inform them of our plans. Find out if they’ll go for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Of course they will,” Mike dismissed the thought.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Perhaps. But we’ll have to get instructions from them. What they want. What kind of time limit we’ll have. Any help they can give us. Equipment. A radio. We’ll need all that.” He looked soberly at his father. “So the first thing we have to do is to make contact with a Resistance group that has the capabilities of reaching London. Easier said than done.”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page46"
    }
  }), _c('a', {
    attrs: {
      "id": "page47"
    }
  })]), _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“We’ll manage,” Mike said confidently. “What else?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We’ve got to get the two British airmen on their way before we leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yeah. Forgot about them.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We can’t handle that ourselves. Any ideas for an escort?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Mike thought for a moment. “Lisette,” he suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin nodded. Lisette. She’d been an escort on two or three trips before. She was dependable, resourceful as well as being one of the more unusual members of the Grand Guignol company. A remarkable woman, she’d joined the Lavettes and their little group in their “railroad operation” as soon as they’d sounded her out.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Now in her early thirties, Lisette in her childhood had had some kind of rare illness that left her bald. No hair, no eyebrows; in fact, she was completely hairless. She wore a wig, of course, and makeup brows, and no one was any the wiser. She played the horror lead in a play called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Machine,")]), _vm._v(" which took place during the early industrial revolution, a sort of one-act "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Metropolis.")]), _vm._v(" In the play, her long hair is caught in the gears of a machine that slowly rips it from her scalp — with strips of skin glowing bloodily in the stage lights. At times her screams were not entirely fake, she’d once confessed, when she suffered a certain discomfort in the process, especially if the gum that glued the wig to her pate had set a little more firmly than planned. Her name was Lisette Maynard. For a while everyone called her May, in honor of the popular European author of stories from the American Wild West, Karl May, whose characters more often than not ended up scalped. She didn’t like it and made it known in no uncertain terms. So her colleagues, respecting her wishes, returned to calling her Lisette.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_vm._v("She was a forceful woman, the kind of female who’d cut the balls off a guy, throw them as far as she could and tell him to fetch. Kevin had thought she was a butch. He couldn’t have been more wrong; a fact he found out when he personally verified that Lisette was indeed hairless. All over. It was a discovery he’d made before he met Gaby.")]), _c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_vm._v(" After that, he’d had eyes — and other parts of his anatomy — for no one else. There had been no other girl in his life. Or in his bed.")])]), _c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin nodded. “Agreed,” he said. “Lisette will do fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Lisette will do fine for what?” It was Gaby’s voice that interrupted them as she entered the dressing room. Unnecessary formalities such as knocking on doors had long since been abandoned at the Grand Guignol. “Need any help with that mini-butcher shop of yours?” she asked Mike.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“All done.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What about Lisette,” Gaby asked again, turning to Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He filled her in.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby was at once excited. She turned to Michael. “I’m so glad you agree with us that we should try,” she burst out. “And I’m so glad you’re coming with us!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin watched the two of them. Got my hands full, he thought. My father as irrepressibly impetuous as a twelve-year-old Little Leaguer; Gaby as spunky and generous as a Disney kiddie-film heroine. It wasn’t a put-down. He rather liked her for it. He remembered what a difficult time they’d had with her when the Nazis had decreed that all Jews in Paris had to wear a yellow star with the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Juif —")]), _vm._v(" Jew — inscribed in the center. To protest and ridicule the German order, many non-Jewish Parisians took to wearing the yellow star with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zulu")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Martian")]), _vm._v(" written on them. Gaby had wanted to join them, but Michael had vetoed it. And it was only by pointing out to her that they must do nothing to call attention to themselves and the Grand Guignol and perhaps jeopardize their operation that she had reluctantly refrained. But he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" enjoyed her “innocent” put-down of a German officer who’d barrelled backstage after a performance and forced his unwanted attentions on her, complaining to her that Paris wasn’t at all what he’d expected. Where was all the fun? he’d whined. All the gaity? The friendliness? The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("joie de vivre?")]), _vm._v(" Oh, Gaby had said sweetly, you should have been here before you came!")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page48"
    }
  }), _c('a', {
    attrs: {
      "id": "page49"
    }
  })]), _c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Three resounding thumps on the stage floor reverberated through the theater and interrupted his thoughts. The stage manager was giving the traditional signal with his staff that the curtain was about to go up.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby turned to Kevin, her eyes aglow. “Tonight,” she said, “after the performance can we start to look for a contact with the Resistance?” She looked from Kevin to Mike.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I have an idea how to start.”")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("“Escort?” Lisette said, arching one painted-on eyebrow. “Sounds fine to me.” With hooded eyes, she looked at Higgins, the big British Flight Sergeant. “It’s the ‘detached’ I may have trouble with.” She looked admiringly at the man’s dashing moustache and put her slender fingers on the biceps of his right arm. “I simply love your moustache,” she cooed. Higgins’s blush rose on his neck like the crimson liquid in a thermometer plunged into boiling water.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Come off it, Lisette,” Michael said, half amused, half annoyed. “You’re not on stage now.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Lisette shrugged, an oddly seductive gesture. “Just being friendly,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The little hiding place behind the Iron Maid was crowded. Besides the two British escapees and Lisette, Michael, Kevin, and Gaby were gathered in the room. It was past one o’clock in the morning, the play was long over, the theater dark — except for the activities of the Lavette Railroad.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You’ll leave tomorrow morning,” Mike continued. “Everything has been prepared. You’ll meet Six-Finger Santis in Tarbes. He’ll take your charges off your hands. Evacuate them over the mountains through the village of Cervera de Buitrago.”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page49"
    }
  }), _c('a', {
    attrs: {
      "id": "page50"
    }
  })]), _c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Lisette nodded. She turned to Higgins. “Sergeant,” she said, “you won’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("believe")]), _vm._v(" it. That little village is the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("wildest")]), _vm._v(" place on earth. Everyone, but everyone, has at "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("least")]), _vm._v(" six fingers on each hand. The Mayor has "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("eighteen")]), _vm._v(" altogether! You can’t hold office unless you have at least twelve. It’s the most —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Lisette!” Michael broke in sharply.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Lisette glanced at him. She smiled at Higgins. “I think he wants me to be quiet,” she said conspiratorially. “Later, we’ll — talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“If you are quite finished playing games, Lisette,” Mike said stiffly, “we’ll get on with it.” He grabbed the big sledgehammer leaning against the wall in one corner. “Stand back,” he said. “Here goes!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He swung the hammer and whacked it against the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It took twenty minutes with the men all taking turns with the sledgehammer before an opening large enough to crawl through had been pounded through the wall to the tunnel beyond.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Mike wiped the sweat from his brow. He pointed to a couple of small set pieces that had been brought into the room: contoured flats representing stone walls. “You know what to do,” he said to Lisette. “Cut the flat that looks most like the tunnel wall outside down to size and plug the hole after we’ve gone through. There’s only a chance in a million, but if a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Boche")]), _vm._v(" patrol should happen by, they may not notice.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Lisette nodded. “It will be done,” she said. She smiled at Higgins. “I am certain the Sergeant will help me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Very well,” Mike said. He turned to Kevin and Gaby. “Grab the flashlights and let’s go.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Mike was the first one through. His light played across the rough tunnel walls. They glistened clammily in the beam. Kevin and Gaby followed him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Put out your flashlights,” Mike said. Instinctively, he spoke in a near whisper. “Save the batteries. One light on at a time is enough.”")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_vm._v("Kevin and Gaby extinguished their flashlights. For a moment")]), _c('a', {
    attrs: {
      "id": "page51"
    }
  }, [_vm._v(" they stood in silence, feeling the depressing eerieness of the place creep through them. Then Mike aimed the beam of his torch up and down the tunnel they’d entered. It was quite narrow and ran straight in both directions as far as the light beam could penetrate the Stygian darkness. The air was musty and cool, the dampness almost tangible. The tunnel was obviously not a main gallery.")])]), _c('a', {
    attrs: {
      "id": "page51"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Which way?” Gaby whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They peered into the chill and dark in both directions. They knew that either way a labyrinth of galleries and tunnels, chambers and caves lay ahead of them, but they had no idea which way would be the quickest to lead them to a cavern used by the Resistance. They only knew that such centers did exist. And that they had to find one.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin pointed down the tunnel to the left. “That way,” he said. “As good as any. I think it leads west. Toward Place Clichy.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Everyone got their chalk?” Mike asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Mike started down the corridor. “I’ll make the first mark,” he said. “On the opposite wall. Twenty paces. Remember that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin and Gaby followed him. Their footsteps on the rocky ground sounded hollow and dead.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby shivered. She was conscious of the dull sound of her heart pounding in her ears. She suddenly remembered the sinister inscription that was written over the main entrance to the catacombs: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stop! This is the Realm of the Dead!,")]), _vm._v(" it warned. She fervently hoped it was not prophetic.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Mike shone his light on his watch. “We have four and a half hours,” he said. “Then we have to be back here. Let’s hope we make contact before then.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Amen,” said Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They walked down the gallery, trying to shake the feeling of oppression that enveloped them. Presently, they came to a side tunnel. On a rotted pole, a sodden sign pointing down the tunnel read: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rue Blanche.")]), _vm._v(" On the wall, a number had been painted in once-white paint.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page51"
    }
  }), _c('a', {
    attrs: {
      "id": "page52"
    }
  })]), _c('a', {
    attrs: {
      "id": "page52"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“I know just where we are,” Kevin said. “That’s the house number on the corner of Rue Blanche and Rue Mansart.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“How do you know?” Gaby asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The tunnels,” Kevin explained to her. “Wherever they follow a street or avenue above, they marked them down here. Years ago. And they painted numbers on the walls corresponding to the house numbers on the streets above. Only the galleries down here are a hell of a lot more complex than the streets up there, so not all the tunnels are marked.” He pointed to the left, down the corridor marked "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rue Blanche.")]), _vm._v(" \"Let’s go that way,” he suggested. “Toward Trinity.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’ll make the mark,” Mike said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Hushed, they made their way through the dark, ghostly city beneath the city, passing deserted traffic circles and empty crossroads, walking through the subterranean streets and alleys in total silence and total solitude.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Where was the Resistance? . . .")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby took Kevin’s arm. “It’s — it’s so eerie,” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("At a place where a flight of worn stone steps blocked by debris led upward, they passed a large flat area filled with dirt and a pile of rotted wooden crates.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Mushroom farm,” Mike said. “Abandoned when the carriage trade was killed off by the automobile. The famous Champignon de Paris needed a lot of horseshit to thrive. I wonder where they grow them now.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Vichy,” Kevin suggested scornfully.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("At another intersection they found a piece of soggy paper stuck to the base of the wall. A page from an old telephone directory.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What’s that doing there?” Gaby wondered.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Chalk,” Mike said. “Paper chalk marks. I’ve read about it. Years ago, people who ventured down into the tunnels took along a telephone book. They’d drop numbered pages from it as they went and checked the numbers when they retraced their steps to make sure they were going in the right direction.”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page52"
    }
  }), _c('a', {
    attrs: {
      "id": "page53"
    }
  })]), _c('a', {
    attrs: {
      "id": "page53"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Pretty clever.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Even so, several of them got themselves lost,” Mike said as he made a chalk mark on the wall. “They were never found.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They’d walked for about an hour through the bleak, soundless world of damp darkness. Kevin estimated they were somewhere under the Boulevard Haussmann area.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Suddenly they stopped. Ahead of them a tiny, steady sound intruded on the silence. A rustling, whispering sound.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin, who was holding the lighted torch, at once turned it off.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Tensely they listened.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The sound continued. Unchanged.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Slowly, quietly, Kevin started to walk toward it. The others followed. The sound grew louder, until it seemed directly ahead of them.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Abruptly Kevin turned on the light and stared.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("From the floor of the tunnel, a little natural fountain bubbled up and rippled down the rutted passageway, gurgling its eternal sound of rustling water.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Unless you want to get your feet wet,” Mike said, “I suggest we go the other way.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They retraced their steps and entered a side tunnel marker RU . . . . . IBE. The paint in the center had peeled off. Mike was again holding the working flashlight. The beam from it was yellowing, the batteries were running down.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Suddenly Gaby gave a sharp little cry. She grabbed hold of Kevin as she seemed to lose her footing and fall. Mike at once shot the feeble light beam on her.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Clinging to Kevin, she teetered on the jagged edge of a gaping hole in the middle of the tunnel floor. Yawning directly in their path, the pitch-black hole appeared bottomless.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin quickly pulled Gaby to safety. Trembling, she held onto him. “What — what is that?” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“A well,” Mike said grimly. “An abandoned well — from God knows when.”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page53"
    }
  }), _c('a', {
    attrs: {
      "id": "page54"
    }
  })]), _c('a', {
    attrs: {
      "id": "page54"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("He shone the light around. At the side of the tunnel the remnants of what appeared to be an old wooden bin formed a ledge.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Sit down for a minute,” he said to Gaby. “We’ll take a break.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gratefully Gaby walked over to the wooden bin and sank down on it. With the scrape of splintering wood, the bin collapsed. Gaby fell to the floor — and with a marrow-chilling, rattling clatter, an avalanche of whitened bones and tiny skulls poured from an opening in the tunnel wall, spilling out over the floor, swamping Gaby with the repugnant remains of death and decay.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She screamed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("At once Kevin threw on his light. He waded into the pile of bones, oblivious to the ear-grating, crunching sound under his feet and hauled the shaken Gaby to her feet. He held her.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Mike picked up one of the little skulls.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Cats,” he said. He looked around. “Cat skeletons. Hundreds of them. What the hell? Someone trying to out-do the Grand Guignol?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin played his flashlight over the bones. “Well, I don’t think its a feline counterpart of an elephant graveyard,” he said. He let his light search the walls. He picked out a painted number. “Of course,” he said. “That’s it. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rue Scribe.")]), _vm._v(" That’s what the street sign reads. There’s a restaurant up there, I remember.” He grinned at Gaby. “Specialized in rabbit stew and wild hare!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“How awful,” Gaby grimaced. She had regained her composure.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“They must have thrown the bones down an old shaft that led down here,” Kevin concluded. “One good thing. I don’t think I ever ate there.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He and Gaby gingerly made their way out of the pile of cat bones.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Mike looked at his watch. “We’ll go on for another forty-five minutes,” he said. “Then we’ll head back.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Skirting the well, he started down the tunnel. Kevin and Gaby followed.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page54"
    }
  }), _c('a', {
    attrs: {
      "id": "page55"
    }
  })]), _c('a', {
    attrs: {
      "id": "page55"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Ten minutes later they came to a star where several narrow tunnels met, radiating from a high-domed cavern like spokes from the hub of a wheel. They selected one, and Mike marked it and the gallery from which they’d come. They started into the side tunnel. They’d walked a couple of minutes when they suddenly froze.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin at once extinguished his flashlight — and they stood in utter darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Ahead of them, the unmistakable sound of several heavy boots clanging on the rocky tunnel floor could be heard coming directly toward them.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Almost at once, where the tunnel made a slight bend, perhaps twenty yards in front of them, they saw the lights from several electric torches glisten on the dank wall, bobbing up and down in time with the marching steps.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Boche!”")]), _vm._v(" Mike whispered urgently. “Quick! Back the way we came. Run!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“They’ll hear us.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Take your shoes off! We’ve got to get out of this tunnel before they pick us up in their beams.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The rocky tunnel floor was hard and cold on their feet as they ran back toward the star in the darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("How far?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Mike was in the lead. Kevin, holding Gaby by the hand, followed closely behind. Totally blind, they raced through the gallery. They dared not use their lights.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Suddenly Kevin heard a soft thud and a choked-off oath.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Watch it,” he heard Mike hiss. “I just ran into the damned wall. On the right.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin slowed down and shifted to the left, taking Gaby with him. They all kept on running. Behind them the flashlight beams were probing around the bend.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They more felt it than saw it. It was the soft, slapping sound of their shoeless feet on the rock that sounded different in tone. They had reached the star cavern.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“This way,” Mike wheezed. “Right.”")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page55"
    }
  }, [_vm._v("Away from the tunnel mouth he turned on his flashlight, holding his hand over it so only the barest glow escaped. It")]), _c('a', {
    attrs: {
      "id": "page56"
    }
  }, [_vm._v(" looked like an explosion of brilliance to them. Mike at once extinguished the torch.")])]), _c('a', {
    attrs: {
      "id": "page56"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“We can’t risk running across the cavern,” Kevin said in a quick whisper. “And we’d have to put on the light again to find the right tunnel. That would be sure to give us away. We’ll stay here. Pick a tunnel that goes back pretty much in the same direction the patrol is coming from. Hurry!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Mike risked another moment of light. The mouth of one of the side tunnels gaped quite close to the one from which the marching steps of the Nazi patrol reverberated ever louder.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They ran for it and dashed inside. A short distance into it, they stopped. Pressing themselves against the rough wall, they stood stock still, breathing their labored breath through their mouths to minimize the tell-tale sound of breathlessness.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And they saw the flashlight beams play on the ground of the cave outside as the patrol entered the star.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Motionless, they waited.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The first of the German soldiers, holding a lighted flashlight, came into view. He started across the expanse.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Suddenly a voice called out excitedly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Herr Feldwebel! Hierher!")]), _vm._v(" — Sergeant! Over here!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There was a quick commotion and several voices speaking agitation.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Merde!”")]), _vm._v(" Kevin swore under his breath. “They found the mark we made at the tunnel. They know it wasn’t there before.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Tensely, they listened to the sergeant crisply issuing his orders. “Two men!” he shouted. “To each tunnel. See what you can find. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Los!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They heard the grating of hobnailed boots on rock as the soldiers spread out.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“On the ground,” Kevin breathed. “Close to the wall. Cover your faces!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Quickly they dropped, huddling close to the base of the tunnel wall.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page56"
    }
  }, [_vm._v("Kevin buried his face in the crook of his arm. He was")]), _c('a', {
    attrs: {
      "id": "page57"
    }
  }, [_vm._v(" able to peek out toward the tunnel entrance only some fifty feet away. He saw the beam of a soldier’s flashlight search the ground outside and the walls near the mouth of the tunnel. Slowly the shaft of light probed deeper and deeper into the tunnel toward them.")])]), _c('a', {
    attrs: {
      "id": "page57"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("It was over. There was no possible way they would not be discovered.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Instinctively he reached for Gaby.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Suddenly a cry rang out from across the star.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Hierher! Noch ein Zeichen! Alle hierher!")]), _vm._v(" — Over here! Another mark! Everyone, over here!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("At once the flashlight beam swung away.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Cautiously lifting their heads, they saw the German soldiers gather at the tunnel through which the three of them had entered the cavern, the tunnel that led back the way they’d come. Back to the Grand Guignol.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There were eight or nine of them, all armed with submachine guns carried at port arms, as they double-timed into the tunnel.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Slowly Kevin and his companions stood up. Soberly, they stood staring into the gloom, watching the rapidly dying flashlight glow coming from the tunnel mouth and listening to the fading footsteps. Finally Gaby spoke, her voice strained and bleak.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Our marks,” she said. “They’ll — they’ll follow our marks back the way we came. Back to the theater.” She felt for Kevin and found him. Tightly she clutched his arm. “Oh, Kevin,” she said miserably. “They’ll — they’ll find the others. Lisette. The Englishmen. Everyone. They’ll take them away. And we led them to them. What can we do?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We don’t have to do a damned thing,” Mike said quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The marks,” Mike explained. “They don’t go all the way back. There is a long stretch where I made no chalk marks at all. I’d rely on landmarks.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What landmarks?”")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page57"
    }
  }, [_vm._v("“The cat skeletons.” Mike said. “The fountain. The well. The mushroom farm. Remember? They would all lead us back. But the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Boche")]), _vm._v(" will have a devil of a time trying to")]), _c('a', {
    attrs: {
      "id": "page58"
    }
  }, [_vm._v(" choose the right tunnels and galleries in that maze of excavations back there. There’s not a chance in a million they’d ever pick up our marks close to the Grand Guignol. They’ll be safe back there.”")])]), _c('a', {
    attrs: {
      "id": "page58"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“But "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("we")]), _vm._v(" have a hell of a problem.” Kevin said gravely.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Just one?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We can’t go back the way we came or we might run into that damned patrol. To be safe, we can’t even go in the general direction.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Then how do we get back?” Gaby asked anxiously.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We’ll have to circle around,” Kevin said. “Get back some other way.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“How? With no markings to follow?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I think I have a general idea where we are,” Kevin said, “in relation to the streets above. At least judging from the last signs we saw. If we can keep our sense of direction, it should be possible to find our way back.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“A damned big "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("if,”")]), _vm._v(" Mike commented.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin turned on his flashlight. He shone it into the tunnel. “If we keep going in that direction for a while,” he said, “and then cut to the left, we should hit the area around the theater.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’s our best bet,” Mike agreed. “We might as well get going. Who knows how long it’ll take.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They put their shoes back on, suddenly aware of their aching feet.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We might even be lucky and find a way out,” Gaby said hopefully. “A way to reach the surface, I mean. We could get back through the real streets up above. It’ll soon be past five thirty. Curfew will be lifted.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We might,” Kevin conceded. But he was only trying not to be discouraging. He knew that the chances of that happening were close to nil.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("His apprehension turned to despair when after more than an hour of walking, he realized they were hopelessly lost. In the eerie subterranean world, his sense of direction had been completely disoriented.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page58"
    }
  }, [_vm._v("In silence they walked through the rocky labyrinth, searching for any familiar landmarks, each one of them")]), _c('a', {
    attrs: {
      "id": "page59"
    }
  }, [_vm._v(" trying to exorcise from his thoughts the dire horror stories of people lost in the tunnels that honeycombed the underground city only to be found as skeletons years or decades later.")])]), _c('a', {
    attrs: {
      "id": "page59"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Mike’s flashlight was dead, the beams from both Gaby’s and Kevin’s already yellowing. Soon the pitch-black darkness would swallow them, rendering them utterly helpless.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They came to a spacious cavern and stopped. Their feeble light beams reached only a little distance into the cave.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We’ll have to cut across,” Kevin said. “Find a gallery on the other side. Toward the left, I think. Perhaps there’ll be a sign to tell us where we are.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They started into the cavern.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Suddenly a blazing white light exploded to life directly in front of them, instantly and totally blinding them. The cold metallic sound of several automatic weapons being cocked echoed through the cave, and a gruff voice cried out:")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Arrêtez! —")]), _vm._v(" Stop! Stay where you are!”")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("Shielding their eyes, they stood bathed in the blinding light.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Who are you?” the voice snapped, its owner invisible behind the glare.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I am Michael Lavette,” Mike said. He took a step forward. “This is my —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Say where you are!” the voice barked. “Don’t move. Just tell me who you are.” The voice was obviously French.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“My son, Kevin,” Mike finished, stopping short. “And Mademoiselle Gaby Kerouac. We are actors from Theatre du Grand Guignol.”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page59"
    }
  }), _c('a', {
    attrs: {
      "id": "page60"
    }
  })]), _c('a', {
    attrs: {
      "id": "page60"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Jacques! Maurice!” the voice ordered from behind the light.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Two grim men appeared through the glare. They walked up to Mike and the others. While one of them covered the three intruders with his gun — a British 9mm Sten Mark II submachine gun, Kevin noted — the other patted them down, efficiently and professionally. A gendarme gone underground, Kevin wondered? Even Gaby was thoroughly though dispassionately searched. Their identification papers were taken, and the men disappeared with them behind the impenetrable barrier of light.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("For a moment there was silence. Then the strong light was turned toward the ground, and gradually they could make out a group of men, all armed with Stens. Four of them.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What are you doing here?” one of the men asked coldly. It was the man whose voice had challenged them.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We are looking for you,” Mike said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Us?” The man’s voice sounded startled.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You are from a Resistance group, are you not?” Mike asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Why?” the man demanded sharply. “What do you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Are you Resistance?” Mike insisted.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I am Etienne,” the man answered curtly. “Now. What do you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It is a long story,” Mike said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Make it a short one.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Mike did. Briefly, to the point, he told about Nicole and her ill-fated team; about their own decision to take on her mission, and their need to make radio contact with London. A capability they did not have themselves, but one that the right command in the Resistance would have.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Etienne listened in silence. He made no comment. “Bring them along,” he ordered his companions. He turned toward the wall of the cave. One of his three comrades motioned for Mike and the others to follow.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page60"
    }
  }, [_vm._v("The light held by Etienne revealed a small opening in the rocky wall. They had to bend down to get through. They")]), _c('a', {
    attrs: {
      "id": "page61"
    }
  }, [_vm._v(" walked in a crouched position for several feet and suddenly found themselves in another high-domed cave, a large cavern lit by several electric light bulbs.")])]), _c('a', {
    attrs: {
      "id": "page61"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("The place was roughly circular, perhaps fifty feet in diameter. Several men and women were busy with various tasks. Kevin noted a telephone switchboard attended by two women; and a small hand-operated printing press where three men in rolled-up shirt sleeves were engaged in turning out what appeared to be anti-Nazi propaganda leaflets. Crates and boxes — some opened, others still sealed — were stacked against one wall, and a row of cots protruded like the teeth of a comb from another. There were a few tables and chairs, a row of battered filing cabinets, and off by itself a generator powered by two bare-chested young men seated on a stationary tandem bicycle, pumping away at a steady pace. One large oil-spotted table apparently served as a machine shop for the repair of small arms, and another — stacked with pots and pans — for the preparation of food.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But most important, he also noted a radio transmitter manned by a woman wearing earphones that pushed down a headful of blonde curls in a strangely attractive manner.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Their guards held them at gunpoint while Etienne, carrying their ID papers, walked over to a man sitting at a table talking with a couple of other men.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They watched in silence as Etienne told their story to the man and showed him their papers. The man studied the documents and glanced toward them. He spoke to Etienne.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Etienne turned and motioned for the guards to bring the three strangers over.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The man seated at the table appeared to be in his middle fifties: graying hair, bushy eyebrows, and finely chiseled features — he could have been a lawyer or a doctor. He stood up as they approached. Gravely, he looked from one to the other, finally fixing his direct eyes on Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The last time I saw you,” he said dryly, “you were blind and wielding a screwdriver.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin let out a sigh of relief. He surprised himself. He hadn’t been aware of how tense he’d been.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page61"
    }
  }), _c('a', {
    attrs: {
      "id": "page62"
    }
  })]), _c('a', {
    attrs: {
      "id": "page62"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“You know us!” he exclaimed. “Thank God! Will you help?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Not so fast, young man,” the Resistance leader said soberly. “I know "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("who")]), _vm._v(" you are. Not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("what.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We are — like you,” Kevin said. “Against the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Boche. Working")]), _vm._v(" against them. Only we are not organized on the scale you are. That’s why we need help. You must understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I hear what you are saying, Monsieur Lavette,” the man countered gravely. “But we have of necessity long since learned never to listen without also seeing and demanding proof that what we hear and see are to be believed. That you must understand.” He looked searchingly at Kevin. “Can you give us such proof?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No more than we already have,” Kevin said. “All we ask is that you contact London. Tell them what Nicole told us. Find out if we can take the place of the — the ‘Jedburgh’ team that was destroyed by the Germans. She said it was code-named Rebus. What risk is there in that for you? Why do you insist on more proof that we are what we say we are, monsieur . . . ?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I am Gerard,” the leader said, “and I will tell you why. It is a matter of trust. Of reliability, which is carefully built up. It would not be possible for us to recommend you to London, not knowing. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“But —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gerard held up his hand. “— or even to tell London what you suggest we tell them without verification.” He looked at Kevin. “Is it not possible that there was no Nicole?” he proffered. “Or, if there were, that you wish to find out her exact mission by taking her place, so you can divulge it to the enemy? Perhaps you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" the enemy.” He fixed Kevin with his direct eyes. “How are we to know?” he added. “How can we be certain that you are indeed, as you claim, working against the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Boche?")]), _vm._v(" Proof, Monsieur Lavette. Proof.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin stared at him. What the hell to say?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Lisette,” Gaby said quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They all turned to her.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page62"
    }
  }), _c('a', {
    attrs: {
      "id": "page63"
    }
  })]), _c('a', {
    attrs: {
      "id": "page63"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Monsieur Gerard,” she said. “Lisette is an actress at the theater. She is one of us. We all help Allied airmen to get back home to England. On a small scale we do this. We help get them out of France into Spain, to Lisbon, and home. That is the operation we are running.” She looked straight at Gerard. “Even now, two British airmen are waiting in our hiding place at the theater. Waiting for Lisette to take them to the railroad station and follow her onto a train for Toulouse. This morning it will be done. Perhaps if you see this happen, you will believe us enough to make contact with London, no?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gerard stared at her. “What time?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The train is at eight forty-five this morning,” Gaby said evenly. “Lisette will leave the theater with her charges one hour before.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gerard looked at his watch. “Less than two hours,” he said. He turned to Etienne. “Etienne,” he said crisply. “Go with Monsieur Lavette and Mademoiselle Kerouac to observe this ‘railroad operation.’ I should like to know how it comes off.” He called to one of the women at the switchboard. “Suzanne! Get me Jean-Pierre on the telephone.” The girl acknowledged his request. He turned back to Mike. “You, monsieur, will stay here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Affronted, Mike began to protest. Gerard stopped him. “It is not what you think, monsieur,” he said. “You are not a, a hostage. I will contact London. Now. I will apprise them of the situation. I will convey to them my reservations. But if — when Etienne gets back — all is well, we can get you an answer from London at once. They will have had a chance to evaluate your proposition. It is, I think you will agree with me, highly unusual. You will therefore stay with me to answer any questions London may have about Nicole and about your plan.” He gave Mike a searching look. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“D’accord?")]), _vm._v(" — Agreed?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Agreed,” Mike nodded.")])]), _c('p', {
    staticClass: "marg"
  }, [_c('a', {
    attrs: {
      "id": "page63"
    }
  }, [_vm._v("Kevin and Gaby followed Etienne through a series of confining tunnels leading from the command cave. Finally they came to a flight of stairs. They ascended the stone")]), _c('a', {
    attrs: {
      "id": "page64"
    }
  }, [_vm._v(" steps and emerged through a trap door in the basement of a house. They made their way up to the ground floor and carne into a kitchen, where an ample woman was boiling soup bones in a large kettle on a wood-burning stove. She barely looked up as Etienne led his charges to the back door. In a narrow alley, a small closed delivery truck converted to burning charcoal was waiting. A driver sat behind the wheel.")])]), _c('a', {
    attrs: {
      "id": "page64"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“In the back,” Etienne said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("All three got in. Etienne closed the door, and they sat in silence in the dark interior of the van.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The ride took about twenty minutes. The truck came to a stop and they dismounted in another alley. On the wall of one of the houses was a prize example of Paris graffiti: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("LES BOCHES AU POTEAU! — The Germans to the Stake!;")]), _vm._v(" and on a fence, a poster with the portrait of a stalwart German soldier. The Star of David had been scrawled across his face.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Having no idea from where they started their ride, they emerged from the alley onto Rue D’Athenes, a stone’s throw from Gare St. Lazare.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A little sidewalk cafe on Rue D’Amsterdam near the station where they sat down to drink a watery-brown liquid masquerading as coffee was next to a bookstore, which — at its peril — displayed in the window large portraits of Hitler and Petain prominently placed next to two volumes of Victor Hugo’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Les Misérables.")]), _vm._v(" After all, even a Gestapo officer might notice the subtlety.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("At a table near them sat three “gray mice” — the Nazi women auxiliary of the Gestapo, thus named by the French because of the color of their uniforms and, perhaps, because of their propinquity to the “rats” for whom they worked. With a superior bearing, they watched the parade of Parisians go by.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Lisette and the two British airmen would pass the cafe on the other side of the boulevard.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It was 8:09.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page64"
    }
  }, [_vm._v("They waited — and reluctantly sipped the unsavory")]), _c('a', {
    attrs: {
      "id": "page65"
    }
  }, [_vm._v(" beverage. Lisette and the Englishmen would soon come into view.")])]), _c('a', {
    attrs: {
      "id": "page65"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("They were on their second cup of the brown liquid when they saw Lisette come walking purposefully down the street, neither too quickly nor too slowly, looking straight ahead. Fifteen feet behind her came Flight Sergeant Alfred Higgins, his magnificent moustache flying at full mast, and fifteen feet behind him, Corporal Henshaw.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There were not many people abroad. Ahead of Lisette, who was wearing a blue coat and a blue hat, walked a woman in a threadbare overcoat and an elderly couple, he carrying his umbrella over his shoulder like a rifle at shoulder arms and she lugging an oversized handbag. Behind Lisette were two nondescript women, and a little farther back, a couple of German Wehrmacht soldiers. It was an ordinary day.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Softly Kevin spoke to Etienne. “The woman in blue,” he said, “Lisette.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They watched as Lisette and her charges came closer, on their way to the railroad station.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The man with the moustache is a British sergeant,” Kevin whispered to Etienne. “The man behind him, his companion.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They watched.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Suddenly Gaby gave Kevin a sharp nudge with her foot under the table. She nodded surreptitiously toward the table with the three “gray mice.” Kevin followed her glance — and at once grew tense.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The German women were all looking in the direction of Sergeant Higgins. One of them touched her nose and giggled. The older of them said something to her, and she immediately grew sober. All three of them stared toward the approaching Higgins, curiosity on their faces. All at once they got up and started across the street.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby felt her stomach knot. Stricken, she and Kevin exchanged glances. The three Gestapo auxiliaries were headed straight for the unsuspecting Higgins.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And there was nothing either Gaby or Kevin could do.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page65"
    }
  }), _c('a', {
    attrs: {
      "id": "page66"
    }
  })]), _c('a', {
    attrs: {
      "id": "page66"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("They watched with rapidly growing anxiety. They saw Lisette discover the three “gray mice” approach across the street, and they saw her realize that for reasons of their own, they were bent on accosting Higgins.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("If they did, he would be lost.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Another few feet . . . .")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Suddenly they saw Lisette speed up her steps. She caught up with the couple in front of her, and passing them she leaned slightly toward the man, lowering her head. When she straightened up, her blonde wig and blue hat were dangling from the tip of the man’s umbrella!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("With a shriek of outrage, Lisette tried to cover her totally hairless pate with her hands while screaming epithets at the man with the umbrella. Startled, the man turned — Lisette’s hat-decorated wig fluttering from his umbrella like a battle standard. Yelling invectives at the top of her lungs, Lisette began to pummel the man, her bald head shaking in rage.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Immediately everyone on the street turned toward the commotion. The three “gray mice” stopped; pointing to the furious, hairless Lisette, they began to laugh derisively. The German soldiers came running to join the fun, and soon Lisette, her bald head bobbing up and down as she battled the bewildered man and his purse-swinging wife, was surrounded by a group of shouting, laughing, and gesticulating Parisians — and the three “gray mice.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Higgins and Henshaw had stopped. They stood in obvious indecision. It was apparent they had no idea what to do. What was happening was not according to script.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It would be only a matter of minutes before the three Gestapo auxiliaries would return their attention to Higgins.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Dammit!” Gaby suddenly hissed. “Rules or no rules, I’m not going to sit here and let those two go to hell!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And before Kevin could stop her, she leaped to her feet and ran across the street.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Under cover of the diversion caused by Lisette, they saw Gaby run to the two British airmen, speak to them quickly, and start to walk toward the station, with both of them following her.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page66"
    }
  }), _c('a', {
    attrs: {
      "id": "page67"
    }
  })]), _c('a', {
    attrs: {
      "id": "page67"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("When they were well past the group around Lisette, they saw the bald girl retrieve her wig, slap it on her head, hat and all, still screaming a stream of indignant outrage at the befuddled man, and finally stalk off after Gaby and the Englishmen, who were just disappearing into the railroad station.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("With a mixture of astonishment and awe, Etienne looked at Kevin. Without a word he rose. Throwing a few coins on the table, he left the cafe and started to walk toward the station. Kevin followed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They were headed for the track from which the train for Toulouse departed when they saw Gaby come striding toward them, a big smile on her face.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“They got on board all right,” she announced. “Lisette, too.” She took Kevin’s arm. “Lisette,” she laughed. “She is a woman to admire!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Mademoiselle,” Etienne said quietly. “So are you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Now do you believe us?” Gaby asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Etienne looked at her.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“There is still a thing to be settled,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("Colonel Dirk A. Baldon, United States Army, stood next to his jeep that was parked at the Main Gate to the Milton Hall Estate, some eighty miles north of London. His fingers drummed an impatient tattoo on the hood of the jeep, his lantern jaw thrust out angrily. He glanced at his watch. 0813 hours. Dammit! he thought, it had to be an American. The last Jed to reach the home roost from the exercise had to be an American. Not a Brit. Not a Frenchman. A damned American. One of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("his")]), _vm._v(" boys. He could already hear the ribbing.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page67"
    }
  }, [_vm._v("The exercise was a good one. That wasn’t it. He himself, had helped lay it out. Take a group of Jeds in training,")]), _c('a', {
    attrs: {
      "id": "page68"
    }
  }, [_vm._v(" put them in a closed truck, take them twenty miles into unfamiliar countryside, and dump them in different places in the middle of the night, with instructions to report back to headquarters in eight hours. Shouldn’t be too damned difficult, except the trainees would have no identification papers, no compass, and only a pencil flashlight and a map on which all the names of the English villages and small towns had been changed to French names. Empingham had become Castillou; Werrington, Entreveaux; and Little Bytham, Draguinan. Only the terrain contours and natural as well as manmade landmarks, all renamed, remained the same. The Jed trainee would have to orient himself solely from those features. Asking questions was, of course, strictly taboo. Anyway, there were few people abroad in the English countryside in the dead of night, and the foreign names on the maps would mean nothing to them, except arouse their suspicions. And that was risky business. The Brits were on their toes and saw Nazi parachutists behind every haystack. A fellow with no papers except a foreign map and a French or American accent would not get far in the helping-hand department. It was the kind of training exercise that offered real risk — the best kind there was.")])]), _c('a', {
    attrs: {
      "id": "page68"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("And the Jeds would need just that. And then some.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page68"
    }
  }, [_vm._v("He’d been with Operation Jedburgh for a few months, having joined shortly after General “Wild Bill” Donovan and his Office of Strategic Services — the OSS — joined forces with the British counterpart, Special Operations Executive — the SOE — and formed the Special Forces, headquartered in London. At SFHQ the Jedburgh concept had been formulated and put into action. Each Jedburgh team would consist of a British, a French, and an American officer, members of SOE or OSS, and an enlisted radio operator. In some cases, one of these Jeds would be a woman. The teams would be dropped in enemy-held territory in advance of the invasion, to collect intelligence")]), _c('a', {
    attrs: {
      "id": "page69"
    }
  }, [_vm._v(" and organize resistance. Since the inception of the operation, the members recruited for it had undergone basic training in Scotland near the little town of Jedburgh, which had lent its name to the operation and which was situated on the Jed Water, a tributary to the Teviot River just north of the English border. But some seven weeks earlier, with the invasion date drawing closer, the Jeds had arrived at Milton Hall for their final training and to form teams. In fact, a few early teams had already been sent into the field: Clover and Quatrain, Rebus and Mars.")])]), _c('a', {
    attrs: {
      "id": "page69"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Again he looked at his watch. 0816 hours. Where the hell was that idiot Hawkins?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Captain Edward “Ted” Hawkins, a West Point infantry officer who’d joined the OSS, had caught his eye from the word go. The man was a good six-two and so solidly built you could throw a tank at him without making a dent. Except perhaps on the gun turret. And with enough self-assurance to fill out his crossword puzzles in ink. So far he had formed no team alliance, perhaps because he was so exasperatingly self-contradictory. Capable of being imaginative and audacious, even brilliant, he’d let his early military training instill in him a strict by-the-book attitude. Hell, in the SF a little bending of the rules was expected. Even encouraged. Like stealing a bicycle to make better time on an orientation run, or matching up the name on a two-bit railroad station with the map and figuring out the other English names and where you were. But not Ted Hawkins when he was in his damned by-the-book mood. If he would only let himself, he could be one hell of a Jed, instead of a hamstrung also-ran. Like now, dammit! The bastard could have been the first one home. Instead, he was already over a quarter of an hour past the deadline.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A jeep came careening down the road from the manor house and came to a stop behind Baldon’s jeep. A sergeant jumped from the vehicle.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Sir,” he said, saluting smartly. “You are wanted in the CO’s office. Urgent, sir.”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page69"
    }
  }), _c('a', {
    attrs: {
      "id": "page70"
    }
  })]), _c('a', {
    attrs: {
      "id": "page70"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Thank you, Sergeant,” Baldon said. He at once got into his jeep. What the hell now? He gave one last look down the road before he started his jeep.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("To the devil with Hawkins!")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("His SOE counterpart in the Special Forces, Lieutenant Colonel Clifton Hillsbotham Ramsey, was already present in the CO’s office when Baldon entered, as well as another British officer, Major Howard Roberts, who ran the teams already in the field, and a French officer, Lieutenant Colonel Jean-Pierre Lamont.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Brigadier James Hindsmith Parnell, looking grim and drawn, sat behind his desk. A wiry, lean Leslie Howard look-alike, he was a man well liked and respected by both fellow officers and other ranks. The Jeds, especially the non-British ones, often affectionately referred to him as “Pips,” because of his insignia of rank, which had three pips and a crown on it, the largest number of pips at Milton Hall. He looked up as Baldon entered.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Ah! Baldon,” he said, “have a seat.” He looked at Major Roberts. “Howard, we are all here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Right, sir.” Howard looked gravely at the other men. “Rebus has been burned,” he said quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There was a general reaction of startled dismay.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“All of them?” asked Ramsey, obviously shaken.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“All of them. Dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Damn!” Baldon exclaimed. Somehow the one word conveyed all his shock, his grief, and anger. “They were good people.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“They are all good people,” the brigadier said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“How do we know?” Colonel Lamont wanted to know. “How was the intelligence transmitted to us?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Through London,” Roberts said. “They had a signal from a Resistance group in Paris. Chap named Gerard has regular radio contact with London. They relayed the signal.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Is Gerard dependable?” Ramsey asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“He has a top reliability rating.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Rotten, bloody luck,” Ramsey muttered.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page70"
    }
  }), _c('a', {
    attrs: {
      "id": "page71"
    }
  })]), _c('a', {
    attrs: {
      "id": "page71"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“We have another serious problem,” Brigadier Parnell said soberly. “The Rebus mission was vital. Perhaps more so than we realize. The entire Fifteenth German Army has been concentrated in the Rebus target area.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Replacement?” Baldon asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You are absolutely right, of course,” the brigadier nodded. “Replacement.” He looked around at the men. “How soon can we get a replacement team operational?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“With the special training and briefing necessary,” Ramsey said crisply, “we can have another team ready in two weeks, I should say.” He looked at the others. They nodded assent.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We may not have two weeks,” the brigadier said quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The invasion?” Baldon asked eagerly. “Has a date been set?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Not yet. But it will not be far in the future, I should think. A matter of four to five weeks.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“So, if we are to put a replacement team in the field, give them enough to find out what’s going on at Mimoyecques, and act on their information, if indeed there is a threat to the invasion, perhaps a serious threat, we’d have to mount a new mission, a new team, day before yesterday,” Baldon said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The brigadier nodded slowly. “That is about the size of it, Colonel,” he agreed. “And since that cannot be done, of course, we must consider other possibilities.” He looked at the officers facing him. “That is why you are here. The signal from Gerard with the Rebus information contained a second part, a rather, eh, unorthodox proposition.” He turned to Major Roberts. “Howard?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Roberts cleared his throat. “Gerard, in his signal, informed us that the people who obtained the intelligence about the aborted mission from the last surviving member of Rebus, before —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Who was that?” Ramsey asked.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page71"
    }
  }, [_vm._v("“Nicole,” Roberts answered him. “Before she died, she told them that it would be quite impossible to find out anything about the nature of the secret project at Mimoyecques, at the construction site there. It is quite")]), _c('a', {
    attrs: {
      "id": "page72"
    }
  }, [_vm._v(" unapproachable. But she said that the information could be had at another place, a place called Misdroy.”")])]), _c('a', {
    attrs: {
      "id": "page72"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Where the hell is that?” Baldon asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“In Germany. On the Baltic coast. About fifty miles north of Stettin.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What’s there?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We do not know, actually,” Brigadier Parnell interjected. “Presumably testing grounds of some sort. Like at Peenemünde, I shouldn’t wonder.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It seems the people who talked to Nicole,” Roberts continued, “are suggesting that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("they")]), _vm._v(" take over the Rebus mission. They point out that they are already in the field and no time would be wasted. It seems they know the Misdroy area rather intimately.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Who are they?” Ramsey asked. “A Resistance group? French Intelligence?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes — and no,” Roberts answered. “They do run a minor operation, getting downed airmen out of France. Rather successful at it, actually. But they are not part of any organized resistance.” He paused. “They are — they are actors, actually.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Actors!” Ramsey exclaimed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“From the Theatre du Grand Guignol.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“That horror thing?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“My word!” Ramsey was shocked. “And "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("they")]), _vm._v(" want to take on a Jedburgh mission?” he said incredulously. “Impossible!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“So it would seem,” Brigadier Parnell said. “At first glance, at least. But, in view of the, eh, rather pressing situation, let us not dismiss the possibility out of hand.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“But — "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("actors,")]), _vm._v(" sir?” Ramsey protested. “Amateurs?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Some of our best Jeds are amateurs, Colonel,” Parnell pointed out. “I shouldn’t be surprised if there were an actor or two among them, what? Some of the most valuable intelligence has been supplied by rank amateurs more than once.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes, but . . .” He let it hang.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page72"
    }
  }, [_vm._v("“How much experience "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("do")]), _vm._v(" they have,” Colonel Lamont")]), _c('a', {
    attrs: {
      "id": "page73"
    }
  }, [_vm._v(" wanted to know. “How do we know they have even a chance of succeeding?”")])]), _c('a', {
    attrs: {
      "id": "page73"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Gerard is checking them out, Colonel,” Roberts answered. “He will transmit his evaluation and recommendation to us as soon as his assessment has been completed sometime today.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Lamont grunted.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“If they’re caught,” Ramsey said, “which seems bloody likely, they could conceivably give away more than they could possibly learn.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What?” Baldon countered. “They know nothing about Operation Jedburgh. They know nothing about our methods or procedure. The Germans already know we are trying like hell to find out about that Mimoyecques project. Those actors couldn’t tell them anything they don’t already know. All they could give away, Cliff, would be their own “railroad operation,” and that’s small potatoes in the scheme of things.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Brigadier Parnell nodded. “I agree with that, Baldon,” he said. “I do not think there could possibly be a security problem.” He thought for a brief moment, then made up his mind. “I suggest,” he said, “that we wait until we have had further word from Gerard before we make a final decision. I suggest that meanwhile we at once select an existing team of Jeds and begin to brief them.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I agree, sir,” Ramsey said. The others nodded assent.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And if Gerard’s recommendation is favorable?” Lamont asked.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page73"
    }
  }, [_vm._v("“Then I suggest we let those, eh, volunteers have a go at it,” Parnell said. “I do think the importance of finding out what is going on at Mimoyecques — what those deucedly mysterious installations actually are and what threat they constitute — warrants that we take advantage of every chance we have,” he continued gravely. “Including using a, a group of people who have no special training. We must, in effect, take advantage of them — and consider them expendable.” He thought for a while. “I want your individual evaluations and recommendations on how we can field this team, and I want them by 1200 hours. If we")]), _c('a', {
    attrs: {
      "id": "page74"
    }
  }, [_vm._v(" do use them, we must give them our best support. We must make the most careful decision possible. In our, eh, profession, even chance cannot be left to chance. I have only one condition myself, I shall want a trained Jed to accompany the chaps from the Grand Guignol. Someone who can be dropped in at once, whose first task will be to evaluate the feasibility of using them, and secondly, to go along with them on the mission to Misdroy.” He looked around. “Any suggestions?” he asked. “I suppose it should be someone who is not already committed to a team. We should not want to break up anything, what?”")])]), _c('a', {
    attrs: {
      "id": "page74"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("The men looked uncertainly at one another.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I have a suggestion,” Baldon finally ventured.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Ted Hawkins,” Baldon said. “Captain Edward Hawkins. He is fluent in both French and German.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Gentlemen?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There were no objections.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Right, then.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We shall need a code name for the team,” Ramsey said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Volunteer,” Roberts suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Grand Guignol!” Baldon said. “What else?”")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("Far from imposing, Etienne thought, as he and Kevin and Gaby walked down the alley from Rue Chaptal toward Theatre du Grand Guignol. He’d never been to the place before, probably one of the few Parisians who hadn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It was still before ten in the morning, and the theater was deserted. Theater people in Paris usually didn’t stir until well after noon.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin unlocked the stage door. He motioned for Gaby and Etienne to wait, and went inside. No use running the risk of bungling into that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("canaille")]), _vm._v(" — that bastard — Choisy or someone else not connected with the railroad operation, who might get curious.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page74"
    }
  }), _c('a', {
    attrs: {
      "id": "page75"
    }
  })]), _c('a', {
    attrs: {
      "id": "page75"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("No one was around, and Kevin and Gaby took Etienne to the stage, which like any stage stripped of its scenery and lights looked cold and barren, with only a naked work light on a stand providing illumination. They led him down the stairs to the gloomy scenery docks below.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Etienne looked around the eerie basement crowded with its ghastly props. “This is where you hide your escapers?” he asked, obviously skeptical.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No,” Kevin said pleasantly, “we hide them in here,” He walked over and pulled open the front panels of the Iron Maid.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Etienne stared into the spiked interior. He frowned. Were they making fun of him? Did they play him for a fool? Angrily, he turned to them.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin reached past him and took hold of one of the crooked spikes. “Allow me,” he said, twisting the spike and pushing the back open. He stepped into the room beyond and switched on the light.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Come on in,” he said to Etienne. “We cannot provide luxury accommodations for our guests, of course, but this does the trick quite nicely.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Etienne gaped at the hidden chamber, taking in everything. He was obviously impressed. He turned to Kevin. “And the, the tunnel?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Over here,” Kevin said. He pushed aside the Japanese screen. Behind it was the hole they had battered in the bricked-up wall. It was plugged with a piece of scenery that showed its unfinished side, with supporting battens and papier-mâché applied over contoured chicken wire.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin removed the plug. “Shall we?” he said, motioning Etienne through the opening. He picked up a flashlight, and the two men entered the tunnel.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Put the cover back,” Kevin called to Gaby. She did.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin played the beam of his flashlight over the set-piece wall plug. It looked quite real. The papier-mâché stonework had obviously been painted to match the tunnel wall. Lisette had done a good job, Kevin thought. Only direct examination would reveal the cover to be fake.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page75"
    }
  }, [_vm._v("Kevin shone his light up and down the narrow tunnel.")]), _c('a', {
    attrs: {
      "id": "page76"
    }
  }, [_vm._v(" “This is where we entered the maze of excavations,” he told Etienne. “It is, I believe, a seldom visited section.”")])]), _c('a', {
    attrs: {
      "id": "page76"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("They went back inside. Kevin replaced the wall plug. Gaby turned to Etienne.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Now, monsieur?” she asked. “Now do you believe us?”")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("It was just before noon. Activities in the Resistance cave were somewhat less hectic than when Mike, Kevin, and Gaby had first been taken there. A few people were sleeping on the cots; there were two different young men pedalling the tandem hooked up to the generator, and the operators at both the telephone switchboard and the radio transmitter were different.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin, Mike, and Gaby were watching Etienne and Gerard off by themselves in earnest conversation. Finally Gerard nodded and walked over to the radio transmitter. Etienne joined the three Grand Guignol actors.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Well?” Mike asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Gerard is going to recommend that you be allowed to carry out your plan to take over the Rebus mission,” Etienne said. “He is contacting London now. We shall see what they decide.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“He was impressed with Lisette, was he not?” Gaby said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Etienne smiled at her. “He was, mademoiselle,” he acknowledged. “But more so with you. I believe it was your reaction, your "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("action")]), _vm._v(" at seeing the charges committed to your care in danger that impressed him most.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What now?” Mike asked. “What happens now?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We will get instructions from London,” Etienne said, “in due time.” He shrugged. “We wait.”")])]), _c('p', {
    staticClass: "marg"
  }, [_c('a', {
    attrs: {
      "id": "page76"
    }
  }, [_vm._v("He had been waiting almost an hour. SS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Standartenführer")]), _vm._v(" Dieter Haupt had consciously had to control his urge to fidget as he sat stiffly on one of the upholstered chairs in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Lange Halle")]), _vm._v(" in the New Reich Chancellery, the imposing one-hundred-and-forty-six-meter-long marble gallery called The Long Hall. It was twice as long as the famous Gallery of Mirrors at Versailles, Haupt knew, and he was impressed. He sat just outside the fully eight-meter-tall")]), _c('a', {
    attrs: {
      "id": "page77"
    }
  }, [_vm._v(" marble doorway that led to the private office of Adolf Hitler, whose initials adorned a golden shield over the double doors. Looking straight ahead, the two SS guards from the SS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Leibstandarte")]), _vm._v(" paid him no attention. Although it was sunny daylight, he noticed irrelevantly that the two ornate gold sconces on the wall flanking the doors were brightly lit.")])]), _c('a', {
    attrs: {
      "id": "page77"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Reichsminister")]), _vm._v(" Albert Speer had summoned him to Berlin on a moment’s notice, informing him that he was to have an audience with the Führer. He wondered what it would be about. And why on so short notice? A whim of the Führer’s? Trouble? Was it because of that accident two days ago? The accident that killed nine foreign workers? He thought not. Accidents were part of forced trials such as the ones being carried out at Misdroy. And real damages had been minimal. What then? He was not worried, but he knew the palms of his hands were moist. Unconsciously, he rubbed them on his sharply creased uniform trousers. It would not do to appear the slightest bit nervous.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Driving from the airport through Berlin, he had been shaken at seeing the destruction inflicted by the Allied terror air raids since their planes began to bomb the city only a short month before. Burned-out buildings. Bomb-cratered streets. Whole sectors demolished.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A deep rage welled in him when he thought of how the enemy had wrought destruction on the Fatherland. And on its capital city. But one ray of solace burned brightly in his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It would be nothing against what his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tausendfüssler")]), _vm._v(" would do to London. To England!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The door to the Führer’s office opened and an Adjutant emerged. He beckoned to Dieter Haupt and stood aside as the young SS officer entered the office.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page77"
    }
  }, [_vm._v("His first impression was one of spacious splendor. The huge room was panelled in rich woods, with a high ceiling of crossed wooden beams. A stern portrait of Bismarck hung over a fireplace mantelpiece at one end of the room; fine paintings adorned the walls; and a golden German eagle soared over the great doors. The furniture was")]), _c('a', {
    attrs: {
      "id": "page78"
    }
  }, [_vm._v(" sparse. A long sofa in a blue-patterned print stood before the fireplace, a massive marble table faced the doors, and the desk of Adolf Hitler dominated the end of the room opposite the fireplace. The desk was surrounded by three upholstered chairs. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reichsminister")]), _vm._v(" Speer, who — Haupt knew — had designed and built the magnificent building, sat in one of them. The Führer was seated behind the desk.")])]), _c('a', {
    attrs: {
      "id": "page78"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Dieter Haupt came to attention with a barely audible click of his heels. His arm shot out in a stiff Nazi salute.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Heil Hitler!”")]), _vm._v(" he sang out.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Hitler rose, walked around his desk, and extended his hand to the young officer.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Mein lieber Haupt,”")]), _vm._v(" he said cordially. “I run delighted to meet you at last.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haupt took the Führer’s hand. He felt the clutch of pride and patriotism tighten his chest. It was a landmark moment for him. He was shaking the hand of Adolf Hitler. The hand millions of people the world over had seen raised in the stirring salutation of the glorious Third Reich; the hand that had guided the fate of the Fatherland to peerless triumphs. And he, SS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Standartenführer")]), _vm._v(" Dieter Haupt, was shaking it. Again he came to attention.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Mein Führer!”")]), _vm._v(" he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Hitler walked back to his straight-backed leather chair behind his desk, which stood on a luxurious Oriental rug beneath a magnificent Gobelin. He motioned to a chair next to Speer.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Sit down, Haupt,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Haupt sat. He noticed the panel of inlaid wood on the front of the desk, facing whoever would be sitting across from the Führer. It was a sword half pulled from its scabbard.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Soon, Haupt thought. Soon it would be pulled out all the way.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Speer has filled me in on the progress of your project,” Hitler said. “But I want to know the details directly from you. Please give me your complete, in-depth account of the status of Operation Busy Lizzie.”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page78"
    }
  }), _c('a', {
    attrs: {
      "id": "page79"
    }
  })]), _c('a', {
    attrs: {
      "id": "page79"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("With pride and enthusiasm SS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Standartenführer")]), _vm._v(" Dieter Haupt began his report.")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("Gerard turned away from the radio transmitter and the message written out by the operator.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“London has authorized you to proceed with your plan,” he told Mike and the others. “But there is one condition.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“They want one of their trained agents to join you. He will be paradropped with instructions and equipment. We are to supply the coordinates for a drop zone. Organize a reception committee.” He frowned. “We do not operate outside Paris,” he said. “It will take a couple of days to set it up.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“A couple of days!” Mike exclaimed. “Why so long?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It is not that simple,” Gerard said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It is.” Kevin turned to Gerard. “I can show you a drop zone we can use right away. Do you have a map of the area around Paris?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Someone produced a military map.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin searched it. “Here,” he said, putting his finger on the map. “Right there is your drop zone.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gerard bent over the map. He turned to the radio operator.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Send these coordinates,” he said. “And tell them they can drop their agent tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("Gaspar expertly kept the wagon wheels in the deep ruts of the dirt road as he drove through the little grove to the secluded alfalfa field on the Marot farm near Meaux. The remote cultivated clearing was bordered on one side by the Marne River and on the others, by the woods. It was well past midnight, and the darkness was all but total among the trees.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Three people rode silently in the back of the wagon: Mike, Kevin, and Etienne. At their feet stood a can of kerosene and four old buckets packed with straw. All the men except Gaspar held a Sten gun across their knees.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page79"
    }
  }), _c('a', {
    attrs: {
      "id": "page80"
    }
  })]), _c('a', {
    attrs: {
      "id": "page80"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Once more,” Etienne said, speaking in a low tone of voice. “The drop will be at 0130 hours. By that time we must each be in position at one of the four corners of the field assigned to us. The straw in the buckets will have been soaked with kerosene, and —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He suddenly stopped, remembering something. “You all have your matches?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin and Mike confirmed. Etienne turned to Gaspar.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Gaspar?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The man grunted.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Bon!")]), _vm._v(" When we hear the plane,” Etienne continued, “wait until you see my bucket lit, then light yours. Is it understood?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes,” Mike and Kevin said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Gaspar?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Another grunt.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Etienne looked at his watch in the light of a small flashlight. “We have better than an hour to set up — and to make certain that the drop zone is clear. We must all be in position fifteen minutes before the time. Agreed?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Agreed.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There was a sudden, violent bump and the wagon swayed as it left the ruts and came to a stop a short distance off the road. Gaspar dismounted and placed a canvas feed bag over the muzzles of the two horses. It would serve to keep them quiet. The men all peered into the darkness. Ahead of them lay the clearing, and the Marne. The stillness lay softly like a black shroud over the land.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We will walk around the clearing,” Etienne instructed them. “All the way.” He suddenly talked in a whisper. “Michael, you and Kevin go to the right. Gaspar and I will take the left.” He began to climb down from the wagon. “Don’t forget your buckets,” he reminded them. “I’ll take the kerosene. We’ll meet on the river bank on the opposite side and soak the straw, if all is well, yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It was not a question that needed an answer. The four men set out in silence.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There was one hour and twelve minutes to the drop.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page80"
    }
  }), _c('a', {
    attrs: {
      "id": "page81"
    }
  })]), _c('a', {
    attrs: {
      "id": "page81"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Damn that bastard, Baldon, Ted Hawkins thought for the umpteenth time. He’d wanted to get into action, sure, but not as a nursemaid for a bunch of lousy ham actors playing secret agent, flashing decoder rings. But he’d had no choice. Pips, himself, had leaned on him. His head still reeled with the mass of information they’d stuffed into it during the few hours he’d had to get ready. It could, of course, all be a crock of shit, but the mission "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("did")]), _vm._v(" sound important; that mysterious construction site, and he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" intrigued. Iron millipedes, for crissake! But, dammit!, what the hell was he going to do with a bunch of greasepaint monkeys?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The steady, deep-throated drone of the twin Rolls Royce Merlin 73 engines on the little De Haviland Mosquito XVI bomber made him drowsy as he sat in the hard seat near the hole in the floor of the aircraft fuselage through which he’d be dropped over the DZ. He eyed the lid covering the hole. He liked the way they did it in the good old US of A a hell of a lot better — out through the side door. Much more civilized. Being chucked out through a hole in the bottom made him feel like a bird-dropping from the asshole of a giant bird. Not a bad idea at that, he thought, if that shithead Baldon would be standing underneath.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He dozed off . . . .")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("He woke with a start. Someone was shaking him. It was the young jump master. Mitchell? Mitchum? What the hell. The Brit NCO.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Fifteen minutes out, sir,” the noncom shouted over the engine noise. “Time to get ready.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Hawkins glanced at the two jump lights above him. The red light was on. The pilot had begun his approach to the drop zone. He looked at his watch. Right on the button.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The NCO checked his chute and hooked the snap-on ring of the parachute static line firmly to the jump cable in the plane. He inspected the equipment package attached to the agent and uncovered the jump hole.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Sit in the hole, sir,” he shouted. “Watch the light.”")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page81"
    }
  }, [_vm._v("Hawkins took his position on the edge of the hole, his")]), _c('a', {
    attrs: {
      "id": "page82"
    }
  }, [_vm._v(" legs dangling down into the black void beneath him. Instantly, the wind tore at him; the cold seemed to bite into his bones. He kept his eyes riveted on the lights. This was for real. Not a piddling training jump. His instructions tumbled through his mind: You’ll be dropped from two thousand feet. “You’ll be on the ground in two minutes. Your reception committee contact is named Etienne. . . .")])]), _c('a', {
    attrs: {
      "id": "page82"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Abruptly, the light turned to green. In the same instant, he heard the jump master behind him bellow, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("go!,")]), _vm._v(" and felt a sharp slap on his shoulder. With the heels of both hands, he pushed himself from the edge of the hole and plunged into the black void.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Instantly a jet of pure force gripped him and slammed him horizontal to the ground as he plummeted into the slip stream. With every possible sense, he waited the eternal seconds for the static cord to rip the parachute from his backpack and for the canopy to be filled with air. The jerk, when it came, was as violent as he remembered.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He reached up, grabbed hold of the risers, and began to check his oscillation, stabilizing his descent. He felt for his equipment package. It was still firmly attached. Already the drone of the plane was disappearing in the distance.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He was alone in the black void. And the silence.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He looked down.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Below, and a little in front of him, he could make out four yellow-red points of flickering light. The DZ. On his right, he could see a pale ribbon of gray convoluting its way through the black countryside. The Marne River.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("His forward momentum carried him slowly toward the drop zone, which loomed ever closer. He felt himself drifting toward the river on his right. Shit! He wasn’t about to be dunked. He corrected, pulling on the left risers, slipping to his left as that part of the canopy above him partly collapsed.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page82"
    }
  }, [_vm._v("He was suddenly aware of the ground rushing up to meet him. Quickly he gave a sharp pull on all four risers, momentarily checking the speed of his descent — and he was on the ground. He rolled in the direction of his fall,")]), _c('a', {
    attrs: {
      "id": "page83"
    }
  }, [_vm._v(" came to his feet, and at once began to haul in the billowing chute as four figures came running toward him.")])]), _c('a', {
    attrs: {
      "id": "page83"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Jed agent Edward “Ted” Hawkins was committed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He freed himself from the harness. Two of the men coming toward him ran to the chute and helped trim it. The other two came up to him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Ted?” one of them asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Ted,” Hawkins acknowledged.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The man broke into a smile. “Welcome to France,” he said. “I am Etienne.” He indicated the man with him. “This is Monsieur Michael Lavette. Mike. He will be on the team with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Mike stuck out his hand. He looked appraisingly at the Jed agent. “We shall be delighted to have you with us, Ted,” he said. His tone of voice did not ring entirely sincere. It was not lost on Ted. The feeling is mutual, chum, he thought. He shook Mike’s hand.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Mike,” he said noncommittally.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Come,” Etienne said. “We must gather our light pots. And your parachute. We must take you to a safe place.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The wagon ride back to the Marot farm was silent. Ted had been introduced to Kevin and Gaspar, but — by mutual consent — any significant conversation would wait until they’d reached the farm.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaspar brought the wagon to a stop in the farmyard near the barn and began to unharness the horses as the four men, led by Kevin, walked toward the main house. It looked dark and deserted.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin knocked on the door.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There was a short wait, and the door was flung open.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Ted stared into the room beyond, and his mouth dropped open in astonishment. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', [_vm._v("10")])])]), _c('p', {
    staticClass: "marg"
  }, [_c('a', {
    attrs: {
      "id": "page83"
    }
  }, [_vm._v("The room beyond blazed with light. Across the back of it,")]), _c('a', {
    attrs: {
      "id": "page84"
    }
  }, [_vm._v(" flanked by two huge green boughs and a frayed and faded Tricolour, a white sheet had been strung, with the words, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("BIENVENU A LA FRANCE MONSIEUR TED!")]), _vm._v(" — "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Welcome to France, Mr. Ted! —")]), _vm._v(" painted in uneven red and blue letters on it. An old windup gramophone began a scratchy rendition of the “Marseillaise” a pretty girl holding a bouquet of flowers stood next to it; and from behind a table laden with bread and cheese and wine, a beaming man, with several World War I medals flopping on his chest as he ran, came rushing up to Ted.")])]), _c('a', {
    attrs: {
      "id": "page84"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Welcome, welcome, Monsieur Ted!” he cried, He enfolded Hawkins in a bear hug and kissed him resoundingly on both cheeks. “I, François Marot, welcome you to my house. A great honor. A great honor!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He rushed back to the table and began to pour wine into several large mugs.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Ted stared. He was slowly recovering from his astonishment. Crazy, he thought, horrified. They’re totally, unequivocally crazy. Turning a serious mission into a three-ring circus, for crissake! And where the hell was the brass band? Heaven deliver him from these — amateurs! His eyes wandered to the equipment package with his radio. First order of business, he thought determinedly, an urgent report to Roberts. Cancel, cancel, cancel!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Cancel — Team Grand Guignol . . . .")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The girl with the flowers came up to him. She gave him a radiant smile. “I am Gaby,” she said. “Welcome! We are so very happy to see you.” She handed him the flowers and kissed him on both cheeks. She smells a lot better than that farmer, Ted thought, but it wasn’t enough to cheer him up.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He took the bouquet. Awkwardly, he stood holding it in front of him. He felt like a damned fool. Like a klutzy homecoming queen on the stage of a high school auditorium, he thought.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The gramophone wound down in a mournful, off-key finish as Mike came up to him. He took him by the arm. “Come, Ted,” he said jovially. “Eat. Drink. We must get to know one another, yes? Tomorrow Gaspar will take us to Meaux and the first train for Paris.”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page84"
    }
  }), _c('a', {
    attrs: {
      "id": "page85"
    }
  })]), _c('a', {
    attrs: {
      "id": "page85"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Resignedly Ted let himself be propelled toward the food table. lt’ll be a long night, he thought glumly. A damned long night. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("He had been right, he thought, as the train rattled over the switch tracks leaving the railroad station at Meaux. It had been a long night. A damned long night. It had been more like a high school reunion than the beginning of a vital intelligence mission. First thing, he fervently vowed to himself, first thing in Paris, off goes a message to Roberts: Forget it!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The taciturn Gaspar had driven them to the station at first light, and they had boarded the early train for Paris, some fifty miles away; he, Mike, Kevin, Gaby, and Etienne, the Resistance fellow. Marot, the kissing farmer, had stayed behind.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Thank God, he thought.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Mike had examined his Milton Hall-manufactured ID minutely and pronounced it perfect. The photographs were the right format, the cards were acceptably dog-eared, and the stamps on them appropriately smudged. Etienne’s Sten guns had been disassembled for the journey and packed in two bundles along with foodstuff provided by Marot: bread and cheese, potatoes, cabbages, and carrots. Apparently a lot of Parisians made sorties into the countryside whenever they could to forage for food to augment their own meager rations or to sell on the thriving black market. His own X-35 radio was packed with a pound of butter, a loaf of bread, and a bunch of beets. His Browning GP-35 9mm automatic was tucked into his belt at the small of his back. He had chosen the American X-35, on which he had been trained in the OSS, over the SOE Type B Mark II, which was built into a small weekend suitcase. Both had a more than adequate transmission range for the mission. But at thirty pounds, the Mark II was the heavier.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The train was fairly crowded, and they kept to themselves as they sat on the uncomfortable wooden seats in silence, watching the countryside roll by.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page85"
    }
  }), _c('a', {
    attrs: {
      "id": "page86"
    }
  })]), _c('a', {
    attrs: {
      "id": "page86"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("They had just left the station at the village of Esbly, about fifteen minutes out of Meaux, when a sudden explosion thundered over them from the distance. It came from behind them and was immediately followed by several even more violent explosions.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The passengers started uneasily. Mike opened a window and leaned out. In the distance, somewhere between Meaux and Esbly, a huge column of dense smoke tinted red at the base rose into the air.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Maquisard,")]), _vm._v(" ” a corpulent man in an expensive though threadbare overcoat with a fur collar said sagely. “Sabotage.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Mais non, monsieur,” a small man with steel-rimmed glasses contradicted him. “I beg to differ with you. Not the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maquis. Les Cheminots —")]), _vm._v(" the rail workers. It is the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Resistance Fer")]), _vm._v(" — the Railway Resistance. There is no doubt.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The corpulent gentleman looked down his ample nose at the contradictor. “And what, monsieur, makes you think so?” he asked haughtily.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The small man spread his hands. “But it is evident, monsieur,” he said. “It is the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bataille du Rail")]), _vm._v(" — the Battle of the Rails — that goes on.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It might as easily be the Maquis, no?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It might. But it is not.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And may I ask, cher monsieur, how you know this?” the corpulent gentleman asked disdainfully.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page86"
    }
  }, [_vm._v("“It is unmistakable. It is how they work, the Cheminots,” the other man answered. “They know the schedules of the German trains, monsieur, from the dispatchers. They do not wish to wreck a French passenger train such as this one.” He looked around at the passengers, all listening to him. “Back there,” he said importantly, “it is where the main railroad line from the south joins this one. From Lyon. From Marseilles. It is then one of the most important lines for the trains to Germany. Many of them with troops going home on leave from their duties of occupation.” He nodded pensively. “I should not")]), _c('a', {
    attrs: {
      "id": "page87"
    }
  }, [_vm._v(" be surprised,” he ventured, “if such a train has been blown up.” He looked pointedly at the man in the big overcoat. “By the Cheminots.”")])]), _c('a', {
    attrs: {
      "id": "page87"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("The corpulent gentleman, out-argued, fell silent.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("For a while the train clattered on. No one spoke. Each was occupied with his own thoughts. What would the Germans do? An uneasy rustle whispered through them as the train sped past the scheduled stop at the Lagny station without slowing down. From the windows they glimpsed rows of armed Waffen SS troops grimly lining the track on both sides.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What was going on?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The answer came quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("At the village of Brou-sur-Chelles the train came to a wheezing halt. Everyone strained to peer out the windows. They were met by an alarming sight. The entire railroad station was surrounded by Waffen SS soldiers, their weapons held at the ready, their faces scowling angrily. They know about the troop train blown up by the Cheminots, Kevin thought bleakly. They know about their comrades. The little man had been right.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The platform where the train was coming to a stop was cordoned off and heavily guarded. At the forward end, a barrier checkpoint had been set up, manned by armed SS men and a few grim-looking civilians. Gestapo.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("When the train had come to a full stop, an SS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scharführer")]), _vm._v(" stepped forward. Legs apart, arms aggressively akimbo, he shouted a command:")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Raus! Alle raus! Schnell! Schnell!")]), _vm._v(" — "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Out! Everyone out! Quickly! Quickly!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Instantly the apprehensive passengers began to collect their belongings. Fearfully they crowded at the doors, shoving, pushing, elbowing to obey, spilling out onto the platform. Roughly, they were gun-butted into groups by the SS troops and herded toward the checkpoint. The Germans were searching for the saboteurs. No one would be spared a thorough examination.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page87"
    }
  }, [_vm._v("And at the feet of the team from the Grand Guignol lay")]), _c('a', {
    attrs: {
      "id": "page88"
    }
  }, [_vm._v(" two bundles with disassembled Sten guns and one with a clandestine radio transmitter the size of a small portable typewriter.")])]), _c('a', {
    attrs: {
      "id": "page88"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Hawkins glared out the window at the scene of chaos and confusion as the passengers milled about on the platform. Damn it to hell! he thought bitterly. Shot down before we even get off the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Etienne suddenly spoke in a sharp, crisp staccato. “The bundles,” he hissed under his breath, “with the Stens. Under the seat. Quickly. No one can connect them to us when they are found.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The radio,” Hawkins said. “What about the radio? It’s vital. Irreplaceable.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“That too,” Etienne said brusquely. “And your gun. London will have to make another drop.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“When, for crissake?” Hawkins blurted out.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“As soon as they can. There will be a delay. But you have no choice.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Where? We sure can’t use Marot’s place. The Krauts will be swarming all over the damned place after this!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin looked at the Jed agent, his eyes bleak. “We’ll think of something,” he said. “Not now.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We’ll have to scrub the damned mission,” Hawkins declared with the snap of finality.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They all stared at him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin’s thoughts raced in his mind. If the mission were aborted even before it had started, London would most certainly be reluctant to reactivate it. They could not lose the radio. Not now. It was as simple as that. They "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" to find a way to save it. And the mission. They "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" to prove their mettle. Right now.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He thought furiously.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Wait!” he suddenly cried. “There is a way.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What?” Hawkins asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Outside, the SS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scharführer")]), _vm._v(" bellowed at the train passengers to get off the train. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Schnell! Schnell!")]), _vm._v(" . . ."), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No time to explain,” Kevin shot back to Hawkins. “Just do as I tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Now wait —” Hawkins started to protest.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page88"
    }
  }), _c('a', {
    attrs: {
      "id": "page89"
    }
  })]), _c('a', {
    attrs: {
      "id": "page89"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“No, Ted. Not now,” Kevin hissed urgently. “No time. Just do as I say!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Something in the actor’s voice silenced Hawkins. He eyed him speculatively.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Shoot!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We split up,” Kevin snapped. “Meet later at the theater.” He turned to Etienne. “Etienne, go. Now. You’ll have no trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Without a word Etienne left.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Gaby, you take Ted. Don’t lose him. Your papers will get you through the checkpoint.” He turned to Ted. “Leave the gun. Give me the radio.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Hawkins hesitated only a split-moment, then he handed the bundle with the radio transmitter to Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Now, go!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby and Ted took off. Kevin turned to his father, who had stood silently by.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Dad,” he said soberly. “Now it is up to you and me. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Holding on to one another, Ted and Gaby were being jostled toward the checkpoint along with the other passengers. Gaby looked back for Kevin and Mike. They were nowhere to be seen. Ahead of them Etienne reached the checkpoint. His identification papers were minutely inspected. He was thoroughly searched — and passed through. Everyone was searched. Every package and bundle ripped open; all the food was confiscated and thrown on a huge pile.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Again Gaby craned her neck to try to catch a glimpse of Kevin and Mike somewhere in the throng of people behind them. Everyone by now was off the train. Several soldiers began to go through the cars, heaving packages and bundles left behind out onto the platform.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There! Fleetingly, she caught sight of Kevin, clutching his bundle with the transmitter in his arms. It looked to be the size of a barn, she thought. How was he ever going to get it through? Oh, dear God, how? And she saw Mike. The two of them were among the last people on the platform. Had they stayed on the train all that time? What had they been doing? Where had they gone?")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page89"
    }
  }), _c('a', {
    attrs: {
      "id": "page90"
    }
  })]), _c('a', {
    attrs: {
      "id": "page90"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("She was suddenly torn from her brooding by a hoarse cry. An SS man was shouting: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Halt! Halt!")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And she saw him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A young man, desperately hurtling down the platform, racing away from the checkpoint in headlong flight. The SS man raised his submachine gun. Once more he shouted: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("HALT!")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But the young man kept running. Men and women passengers scrambled to get out of his way.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("And the SS man opened fire.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A burst of 9mm bullets ripped into the man, disintegrating one of his legs at the hip. He spun around as if struck by an invisible fist and pitched heavily to the ground. A convulsive spasm wracked his body and a piteous scream tore from his throat.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Another soldier joined in the shooting. An elderly woman, clutching a package wrapped in newspaper and tied with string, was not able to get out of the line of fire quickly enough. Several of the bullets caught her in the chest, and with a look of utter astonishment she collapsed, her bundle splitting open as it hit the ground, spilling a hoard of new potatoes that rolled out onto the concrete, to be colored crimson by the blood that spurted from the woman and mingled with that of the youth.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("An elderly man, with a cry of anguish, started to run toward the woman. SS men held him back.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("One of the soldiers stalked up to the young man and turned him over with his booted foot.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The boy was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("So was the woman who had not been quick enough — or young enough — to get out of the way. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby stared in horror. She was deeply shaken. Her entire face felt numb. She had never seen violence before. Not like this. Only make-believe at the theater. She had never seen — death. She shuddered. It — it could have been Kevin. She felt the hot tears sting her eyes. She held onto Ted, digging her fingers into his arm — and they were at the checkpoint.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page90"
    }
  }), _c('a', {
    attrs: {
      "id": "page91"
    }
  })]), _c('a', {
    attrs: {
      "id": "page91"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("While an SS man gruffly patted them down, a Gestapo officer inspected their papers. He looked searchingly into their faces — and let them pass.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They joined Etienne, and together they stood on the platform beyond the barrier, watching with the other passengers who had passed inspection. Off to one side, held at gunpoint by Waffen SS troops, stood a small group of frightened people who had not been that lucky.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("With all the passengers off the train and all the coaches searched, the train gave a jerk and slowly inched forward past the checkpoint and stopped, ready to board the passengers for the continuation of their interrupted journey as soon as all of them had passed through the checkpoint.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Or had been taken away.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby was worried. Where were Kevin and Mike? Had they gotten away? Impossible. There was no way for them to get through the cordon of soldiers ringing the station, standing almost shoulder to shoulder. She strained to see, but she could not find either Kevin or Mike in the crush of people still apprehensively waiting to be examined.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Two soldiers came up to the officer at the checkpoint. In their hands they had two bundles. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Their")]), _vm._v(" bundles, Gaby saw with sudden alarm. Ripped open, the disassembled Sten guns could be seen. The officer pulled out a gun barrel and examined it. For a moment he conferred with the Gestapo man. He pointed toward the dead youth still lying on the platform — the passengers making as wide a circle around him and the woman as they could.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The Gestapo man nodded slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby drew an inaudible sigh of relief. The Germans obviously believed that the weapons had belonged to the dead youth. Reason enough to try to flee. She felt a pang of part grief, part guilt. The boy had been too young to die so horribly. But — is not everyone?, she thought. At least suspicion that others not yet discovered might have jettisoned the weapons had been allayed. For now.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page91"
    }
  }, [_vm._v("Suddenly a man elbowing his way through the crowd")]), _c('a', {
    attrs: {
      "id": "page92"
    }
  }, [_vm._v(" came hurrying up to the officer at the barrier. A couple of SS men at once tried to stop him, but the officer waved them off.")])]), _c('a', {
    attrs: {
      "id": "page92"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("In obvious agitation, the man began to talk to the German.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Startled, Gaby saw it was Mike.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Raptly, she and the others watched — unable to hear what Mike was saying.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He was obviously distraught. Waving his arms animatedly, he appeared to be pleading with the officer — gesturing back at the crowd of passengers still waiting to pass through the checkpoint.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Suddenly he stopped and pointed excitedly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The officer looked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Far back on the platform, close to the abrupt drop down to the track, Kevin could be seen stumbling awkwardly about, obviously in trouble, still clutching the big bundle to him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby gave a startled gasp. She recognized Kevin’s helpless motions as he fumbled about. He was playing at being blind! As in the insane asylum play at the Grand Guignol.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("What on earth was he doing?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She saw Mike start to run back toward his son — and she saw him being roughly restrained by two SS men.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She saw two other soldiers walk back, take hold of Kevin, who started violently at their touch, and drag him back to the checkpoint. Trembling, his “blind” eyes searching without seeing, he appeared panic-stricken. She saw Mike talk to his son and take him by the shoulders, and she saw Kevin grab hold of his father in desperate need.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Once more Mike gesticulated his appeal to the officer. He pointed to Kevin’s eyes; he rolled up his sleeve and showed the German his artificial limb. With both arms, he made a wide gesture, as if describing a big explosion, and he hugged his son in comfort.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The German officer listened grimly. He motioned to a couple of SS men, who searched both Mike and Kevin while the officer inspected their identification papers.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page92"
    }
  }), _c('a', {
    attrs: {
      "id": "page93"
    }
  })]), _c('a', {
    attrs: {
      "id": "page93"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Finally he returned the papers to Mike and waved them through.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby exulted. They’d done it!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Suddenly the officer barked a crisp command. Instantly an SS man tore the big bundle from Kevin’s arms.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A chill of fear shot through Gaby. Mike’s plan was going awry. He and Kevin were caught. In her mind’s eye she suddenly saw them both lying dead on the platform in a pool of blood next to the ill-starred youth and the old woman.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("In horror she watched as the SS man ripped open the bundle, spilling a profusion of vegetables and other foodstuff out on the concrete. Vegetables, a loaf of bread, a chunk of cheese. But there was no sign of the typewriter-sized X-35 radio transmitter.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Where was it? Had they hidden it somewhere, planning to return for it later? Bleakly Gaby knew that if they had, their plan would fail. The Germans would be going over the entire railroad station inch by inch. They would expect contraband to have been hidden. The radio was lost.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("For a moment the Germans stood looking at the food, then one of them kicked it onto the steadily growing pile of confiscated provisions on the platform and gruffly pushed Mike and Kevin through the barrier.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Complaisantly Mike guided his son through the waiting crowd toward the train standing by on the track, walking past his friends without a sign of recognition. He and Kevin, anxiously holding his father’s arm, took up positions close to the door of one of the railroad cars and began to wait. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("It was almost noon when Kevin and Mike showed up at the Grand Guignol.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby, Ted, and Etienne were sitting in Mike and Kevin’s dressing room. They looked glum.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What the hell kept you,” Ted growled as they walked in.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page93"
    }
  }, [_vm._v("“Just being careful,” Kevin answered pleasantly. “We")]), _c('a', {
    attrs: {
      "id": "page94"
    }
  }, [_vm._v(" wanted to make absolutely certain that there was no one sticking around to see what we were up to before we came here.”")])]), _c('a', {
    attrs: {
      "id": "page94"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Ted grunted, obviously not impressed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What on earth were you doing at the checkpoint?” Gaby asked Mike.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Playacting,” Ted grumbled disgustedly. “Grandstanding.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("did")]), _vm._v(" you say to that officer, Mike?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I told him a fairy tale, cheri,” Mike said cheerfully. “I told him that Kevin was my son. I told him he was blind, as he could see, and that we had become separated in the confusion. I told him I was afraid my son might not understand, might not react properly to a command, and perhaps be shot like that other young man. I told him we had both sacrificed much for the German cause. My son his eyes and I my arm. In an accident. An explosion when we were helping to build the fortifications on the English Channel coast.” He chuckled delightedly. “I think he believed me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“But why?” Gaby wanted to know.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Simple, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ma petite chou-chou.")]), _vm._v(" To draw suspicion away from us. People who have something to hide do not make spectacles of themselves. So, we did. As it were,” he said gleefully. “We almost got the bundle through!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Bloody bully for you,” Ted said acidly. “But you didn’t. The damned radio is lost. I’ve already asked Etienne to send a message to London to scrap the mission.” He glared at Mike. “What the hell did you do with the damned thing?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Do with it?” Mike asked innocently. He was enjoying himself. “Why, nothing. It’s right here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He rolled up his sleeve, unstrapped his prosthesis, and spilled a jumble of tubes and transistors, condensers and converters, partially assembled segments of circuitry, modulators and demodulators, resistors, amplifiers, and oscillators out on the table.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They all stared at it.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page94"
    }
  }, [_vm._v("“It’s all there,” Kevin said. “All the special, irreplaceable")]), _c('a', {
    attrs: {
      "id": "page95"
    }
  }, [_vm._v(" parts. All the unique X-35 items. All there. The only parts missing are commonplace radio components. Etienne can easily replace them. And, of course, the housing. But it will be a simple job — a matter of a couple of hours — to reassemble and rebuild the transmitter into a new casing.”")])]), _c('a', {
    attrs: {
      "id": "page95"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Ted leaned over the table. He fingered the radio parts.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’ll be damned,” he said. “I’ll be triple damned!” He looked at Kevin and Mike, reluctant respect in his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He turned to Etienne.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Etienne,” he said. “Change that message to London. Send instead — "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Grand Guignol is go")]), _vm._v("!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin grinned at his father. He felt great. They had proven their mettle. In spades.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("There was a sudden knock on the door.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They all looked toward it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Quickly Gaby threw a towel over the radio parts on the table. Kevin opened the door.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("In the open doorway, frowning suspiciously, stood the theater manager, Camille Choisy.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Behind him stood two SS officers, their black uniforms immaculate and forbidding, the silver death heads gleaming ominously on their caps. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('span', [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("“Ah! Lavette,” Choisy addressed Michael. “I see you have company.” There was acrimonious disapproval in his dry voice. “It is, however, of some importance that I speak with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin rose and took a step toward the theater manager.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Monsieur le Directeur,” he said expansively. “Please come in.” He gestured toward Etienne and Ted. “My father and I were just discussing with these gentlemen the feasibility of making the replacement prostheses for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lumberman’s Revenge")]), _vm._v(" at a lesser price.”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page95"
    }
  }), _c('a', {
    attrs: {
      "id": "page96"
    }
  })]), _c('a', {
    attrs: {
      "id": "page96"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“I see,” Choisy said, considerably mollified. He stood aside and nodded respectfully to the two SS officers who stood with him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“May I present "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hauptsturmführer")]), _vm._v(" Hildebrandt and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Obersturmführer")]), _vm._v(" Schindler.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The two officers made a small bow, carefully calibrated to show only the minimum degree of courtesy.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The Messieurs Lavette and Mademoiselle Kerouac are members of our Grand Guignol company,” Choisy told the Germans. “They will be participating in the performance of the requested play.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The officers barely acknowledged the information.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What can we do for you, Choisy,” Mike asked, able to control his distaste only with difficulty.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Ah!” Choisy said importantly. “The matter is as follows. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generalstabsarzt")]), _vm._v(" of Army Group West, General Gerhardt Riekhoff, is on a visit to our city. He has done us the great honor of expressing his desire to see a performance of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lighthouse Keepers.")]), _vm._v(" So we shall present it tomorrow instead of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Asylum,")]), _vm._v(" which, as you know, was scheduled. It will, of course, require some special attention.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I see,” Mike said. “There should be no problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Ah. Well. I rather thought not,” Choisy said. “The Captain and the Lieutenant will be in charge of, ah, special security in connection with the attendance of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generalstabsarzt.")]), _vm._v(" They have requested that they be given a tour of inspection of the theater, and I thought, I thought you, Monsieur Lavette,” he nodded to Mike, “would be so good as to show the gentlemen around.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“But of course, Monsieur le Directeur,” Mike said. Inwardly, he seethed, but dammit! this was not the time to do any boat rocking.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Excellent,” Choisy exclaimed. He stepped back to give Mike room to join the Germans. He put his hand on the makeup table and got a smear of greasepaint on it. He reached for the towel that covered the radio parts on the table.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page96"
    }
  }, [_vm._v("Quickly Gaby stepped in front of him. She reached for a")]), _c('a', {
    attrs: {
      "id": "page97"
    }
  }, [_vm._v(" clean towel on a shelf and handed it to the theater manager. “Please, Monsieur le Directeur,” she said sweetly. “Use this clean one.”")])]), _c('a', {
    attrs: {
      "id": "page97"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Choisy nodded, his attention on Mike and the SS officers. He took the towel, wiped his hand, and threw it on the table.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The tiny tinkle of glass went unnoticed by both Choisy and his visitors.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Perhaps the gentlemen would like to begin with an inspection of our first-aid room?” Mike inquired of the officers. “I believe we have a bottle of quite excellent brandy there. For medicinal purposes, of course.” Without waiting for a reply, he turned to Etienne and Ted. “You will excuse me, Messieurs. My son will continue our discussion. He is fully as knowledgeable in the matter as I am myself.” He turned back to the officers. “This way, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("With a glance at Kevin he walked off, followed by the two Germans and Camille Choisy.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("For a moment after the unwelcome visitors had left the little dressing room, no one spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It will not interfere with any possible plans, is that not so?\""), _c('em', {
    staticClass: "italic"
  }), _vm._v(" Etienne asked worriedly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It will not,.” Kevin said. “It may be a little awkward to have to contend with a big-shot Nazi, but we’ll manage.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Riekhoff,” Ted said pensively. “I know who he is. He’s Chief Medical Officer of von Rundstedt’s Army Group.” He snorted. “I had to learn the whole damned TO [Table of Organization] of von Rundstedt’s command in my training.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What’s he doing going to the Grand Guignol?” Kevin wondered sourly. “Busman’s holiday? Doesn’t he see enough blood and gore to satisfy his Nazi heart’s desire?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Beats me,” Ted said. “And I couldn’t care less. But it gives me a hell of an idea.” He looked at the others. “We have to come up with a way to infiltrate Germany and get to Misdroy as quickly as possible, right?” he paused. He nodded toward the door.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Perhaps those two Nazi flunkies have handed us a solution on a silver bedpan!”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page97"
    }
  }), _c('a', {
    attrs: {
      "id": "page98"
    }
  })]), _c('a', {
    attrs: {
      "id": "page98"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("SS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Standartenführer")]), _vm._v(" Dieter Haupt idly watched the two motorcyle outriders hurtling before him along the road from Calais to Antwerp. He was impressed with the skill of his driver — the distance between the outriders and his staff car never varied.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He stretched and sighed deeply. It was good to be able to relax. He had been driving himself too hard, and he knew it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("After his memorable meeting with the Führer, he had at once flown to Calais and Mimoyecques on a tour of inspection that had been interrupted by his summons to Berlin. He had decided to return to Misdroy from Mimoyecques via surface routes rather than by air. He needed the time to rest, and he knew that the moment he’d get back to the test site there would not be a minute he could call his own. He had opted to go by car. It was a long ride, some eight hundred kilometers, but he’d make it in one day. One long day. He preferred cars to trains. More control. And he liked to have control. He could stop wherever he wanted, whenever he wanted, and he could take whatever route he deemed the most expedient. And, best of all, he would be able to rest — he slept soundly in a car — and, of course, prepare his report to Reichsminister Speer, based on his inspection of the Mimoyecques installation, undisturbed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He placed his briefcase across his knees to use as a makeshift desk. He started his notes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Punkt —")]), _vm._v(" item: Foreign workers at Mimoyecques. At the present, 5,500 on a 24-hour shift. Request to be made for a weekly allotment of a minimum of an additional 10 percent of this number to make up for losses.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page98"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Punkt:")]), _vm._v(" Since the severe damage inflicted by the Allied air strikes of November last year on the construction site at Mimoyecques, only minimal air-raid damage has been experienced. The cover roofing of eight meters of concrete has proven impenetrable by enemy bombs. Vulnerable, however, is the system of railroad tracks that lead to the entrances at the base of the installation. Although the eight-meter-high, two-meter-thick sliding steel doors provide")]), _c('a', {
    attrs: {
      "id": "page99"
    }
  }, [_vm._v(" adequate protection for the site itself, the rail network is exposed to damage. Consequently, antiaircraft defenses must be kept at full strength, and railroad workers and materiel must be constantly available for repairs.")])]), _c('a', {
    attrs: {
      "id": "page99"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Punkt:")]), _vm._v(" As it is apparent that the enemy has mounted a concerted intelligence effort to both discover the purpose of the construction site at Mimoyecques and to penetrate it, it is imperative that the Fifteen Army be kept in the area as security.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Punkt:")]), _vm._v(" For the same reason, security must be strengthened at Misdroy. Request must be made for additional "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Waffen")]), _vm._v(" SS troops.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Punkt:")]), _vm._v(" Progress at Mimoyecques is ahead of schedule. No problems foreseen. All three shafts have reached the depth of 160 meters and have been widened to 17 meters in diameter. The 70 by 30 meter "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Betonplatte")]), _vm._v(" — concrete platform — at Level A has been completed and camouflaged. Work on Level B is nearly completed, and work on levels C and D is progressing rapidly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Punkt:")]), _vm._v(" Progress at Misdroy has experienced some unavoidable mishaps, all correctable and all leading to improvements. Perfection of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tausendfüssler")]), _vm._v(" is expected within two to three weeks, at which time Mimoyecques should be ready to become operational.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Punkt:")]), _vm._v(" Project Busy Lizzie is proceeding as planned.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He sat back in his seat. What else?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He closed his eyes. The gentle swaying of the car lulled him. He pushed the briefcase off his lap and settled into a corner. Perhaps after a nap he’d think of something else. And he’d organize his notes and put them into proper language. Later.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He pulled his travel blanket over him, and within minutes he was asleep. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("Mike watched the two SS officers walk to their car, parked in the theater alley. A driver noncom, seeing them approach, jumped out. He gave a smart, stiff-armed salute and held the door open. The officers got in and the car drove off.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page99"
    }
  }), _c('a', {
    attrs: {
      "id": "page100"
    }
  })]), _c('a', {
    attrs: {
      "id": "page100"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("When Mike returned to his dressing room, the others were all still there, talking animatedly. They looked up as he entered.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I feel like taking a bath in boiling water,” Mike grumbled disgustedly. “Those two Nazi bloodhounds were all over the place. Even sniffed around the Maid.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Any trouble?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Mike shook his head. “They didn’t know what the hell they were looking for. Just showing off their importance,” He snorted disdainfully. “But "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I")]), _vm._v(" found out a few things.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“There will be four SS guards here tomorrow. Two in the auditorium, one in the foyer, and one inside the stage door.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Taking no chances, are they?” Kevin remarked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The general will be accompanied by four other officers in addition to the Bobbsey Twins, Hildebrandt and Schindler. There will be two cars with drivers parked in the alley.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Great!” Kevin exclaimed. “Fits right in with the plan.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Plan? What plan?” Mike asked, puzzled.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Ted’s plan,” Kevin answered him. “To get us to Misdroy.” He turned to Ted. “Tell him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Ted did.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("When he was finished, Mike looked at him, his mouth slightly agape.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Holy shit!” he said. “It might work. It might damned well work!” He looked eagerly at the others. “Can it be done? Can we do it?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin nodded. “We are sure we can. It sure beats all the other ways that we could get there. Trains. Bikes. All that. Ted has already given Etienne a shopping list of what we’ll need.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Etienne handed Mike a piece of paper. “Here,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Mike read it, his eyes growing wide. “What?” he commented. “No kitchen sink?” He looked hard at Etienne. “Are you certain you can get all this stuff? And complete the necessary paper work?”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page100"
    }
  }), _c('a', {
    attrs: {
      "id": "page101"
    }
  })]), _c('a', {
    attrs: {
      "id": "page101"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Etienne nodded. “I am certain.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Lisette is due back later today,” Gaby said. “I’m sure she’ll do her part and do it well.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“So am I,” Etienne affirmed. He was obviously a fan.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby smiled at him. “Your faith is well placed, Monsieur Etienne,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Then, according to this,” Mike said, waving the paper in the air, “we should be on our way in no more than forty-eight hours.” He turned to Etienne. “How much time will you need after tomorrow’s performance?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Twelve hours,” Etienne answered, “at the most. But we must make certain the job is done as well as absolutely possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Amen!” Kevin said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You have the right people?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We do. We will also have Monsieur Ted’s radio rebuilt.” He looked at Ted. “And to replace your lost gun, your Browning, I shall give you an Astra, if you. wish me to. It is a Spanish-made, nine millimeter automatic. It is capable of accepting and firing almost every type of nine millimeter automatic rounds, including the Luger and the P-thirty-eight. It might be useful in Germany.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Thanks. I accept,” Ted said. “I am familiar with the Astra. It’s a damned good little handgun.” He looked at the others. “Under the circumstances, I don’t think anyone else should carry a weapon on the mission. It would be a dead giveaway if we are detained and searched.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Okay with me,” Kevin said. “No arms.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Speak for yourself, son,” Mike grinned. “I plan on taking along an extra arm or two.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It’s settled, then,” Ted said. “We jump off at noon day after tomorrow.” He looked around at the others. Not such hayseeds as he’d thought at first.” Send the message to London, Etienne,” he said. “And include our time schedule. We are committed.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He grew sober.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It all depends on what happens during the performance tomorrow night,” he said.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page101"
    }
  }), _c('a', {
    attrs: {
      "id": "page102"
    }
  })]), _c('a', {
    attrs: {
      "id": "page102"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('span', [_vm._v("12")])]), _vm._v(" "), _c('p', [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("HUMP! Thump! Thump!")]), _vm._v(" The hollow thuds boomed through the theater as the stage manager banged his staff on the stage floor, signaling the curtain was going up. The houselights were dimmed down and out, and the curtain at the Grand Guignol went up to reveal a darkened, moody stage with a set representing the round living quarters in a lighthouse. Dim light was reflected in a rhythmic cycle on the “fog” produced by a smoke pot outside the windows, and a doleful fog horn wailed in the distance. From a spiral staircase leading to the stage from the basement below, Mike and Kevin, father and son in the play as well as in life, came up into the Spartan room. Mike went to a kerosene lamp and turned it up. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lighthouse Keepers")]), _vm._v(" had begun.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("As Mike turned from the lamp he glanced at the front row in the audience, now faintly bathed in the light from the lit stage. The row was resplendent with the dress uniforms of several high-ranking Nazi officers.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jed agent Ted Hawkins’s plan had also begun. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby and Lisette giggled coquettishly together as they walked from the theater toward the two German staff cars parked in the alley. Two noncom drivers stood talking at the first car, which flew the standard of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generalstabsarzt.")]), _vm._v(" Each of the girls had a bottle and a glass in her hands. They exchanged glances. Lisette nodded. They walked up to the drivers.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Bonsoir,” Gaby said pleasantly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Bonsoir,” the drivers said almost in unison, their German accents making the soft French word sound guttural.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It is a long wait you will have out here,” Gaby said. “We thought you might like a little something to warm you.” She held up the bottle, but it was quite obvious that was not the only warmer-upper she had in mind.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Both the drivers grinned with anticipation.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Merci, mademoiselle,” one of them said. “That is very kind of you.”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page102"
    }
  }), _c('a', {
    attrs: {
      "id": "page103"
    }
  })]), _c('a', {
    attrs: {
      "id": "page103"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Lisette looked brazenly at the other driver. “Which car do you drive?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The driver pointed to the second car. “That one,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It is chilly,” Lisette said, putting her arms around her in a sensual gesture. She locked her bedroom eyes onto the German. “Perhaps we could go and — sit in your car while you warm yourself with — with a little drink?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Bitte,”")]), _vm._v(" the driver said eagerly, all but licking his chops. “Please. After you.” He motioned Lisette toward the car.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Lisette walked over to the car, her hips swinging provocatively. The driver followed. As Gaby saw them get into the car she turned to the driver of the general’s staff car. She knew she need not worry about the other driver for quite a while. Lisette would keep him occupied as only she could.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Can we sit in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("your")]), _vm._v(" car, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Herr Unteroffizier?”")]), _vm._v(" Gaby asked, wide-eyed. “Is it permitted?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Of course,” the driver said. “Climb in.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("They both climbed into the back seat of the car. Almost at once the German grabbed for Gaby. Laughing teasingly, she drew back. “A little drink first,” she said seductively. “You call it schnapps, yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Schnapps it is,” the driver said. He seized the bottle and took a hefty swig. He shook his head vigorously. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Ist gut.”")]), _vm._v(" He smacked his lips and gave Gaby a lecherous grin. He put one arm around her and began to feel her breasts with the other.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby did not fight him. She knew he would stay conscious for less than thirty seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She was right.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She pushed the unconscious German away from her. Quickly she searched him, removing all papers and identification on him. Then she turned her attention to the car. In the front seat she found a clipboard with several papers and documents clamped onto it. German travel permits. Licenses. Authorizations. She removed them and stuffed everything into her dress.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page103"
    }
  }, [_vm._v("She glanced back toward the other car. Neither Lisette")]), _c('a', {
    attrs: {
      "id": "page104"
    }
  }, [_vm._v(" nor the driver were to be seen. Quickly she stepped out of the car and hurried back toward the theater.")])]), _c('a', {
    attrs: {
      "id": "page104"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("The storage basement was deserted and quiet except for the voices of the actors on the stage above, faintly heard. Quickly Gaby made her way to the Iron Maid. She entered the room beyond.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Etienne looked up. “You have it?” he asked urgently.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby nodded. “I do.” She pulled the papers from her dress. “You must be quick. The man will be out only twenty minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I will.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Etienne strode to the table. On it a camera had been mounted on a stand. He turned on a strong light, and one by one he photographed the papers Gaby had brought.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Fourteen minutes later Gaby stepped back into the general’s car. Quickly she replaced all the papers she had taken. She sat down in the back seat next to the German driver and cradled his head in her lap.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("It was only a few minutes later when he stirred.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You are quite a bear, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Herr Unteroffizier,”")]), _vm._v(" Gaby said as he groggily sat up. “The girls must love you very much.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Uncomprehendingly, the man stared at her.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She smoothed her dress and her hair. “But I have been much too long, cheri,” she worried, a pretty little frown creasing her forehead. “I will be missed if I do not return.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She gave the man a peck on the cheek and stepped out of the car, leaving a thoroughly perplexed German staring after her.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Outside, she stopped and waved at the second car. A few moments later Lisette, looking slightly dishevelled, came out from the car. She joined Gaby, and the two girls, carrying their bottles and glasses, sashayed back to the theater.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Stage one of the Hawkins plan had come off without a hitch. . . .")])]), _c('p', {
    staticClass: "marg"
  }, [_c('a', {
    attrs: {
      "id": "page104"
    }
  }, [_vm._v("The jury-rigged directional antenna had been built in the attic of the house on the alley where Kevin and Gaby had emerged from the Resistance caves. Was that only three")]), _c('a', {
    attrs: {
      "id": "page105"
    }
  }, [_vm._v(" days ago? Gaby thought. It seemed like an eternity. It was the kind of antenna Ted would have to erect when he wanted to transmit from Germany. Quickly, crudely made. But effective.")])]), _c('a', {
    attrs: {
      "id": "page105"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("In the attic, the Grand Guignol members and Etienne were anxiously gathered around Ted and his rebuilt X-35. It was a crucial moment. The radio had to work. It "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" to. Everything depended on it.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Using the double-transposition words given him at Milton Hall, Ted had encoded a short, to-the-point message for transmission. He wanted to be on the air the shortest time possible. There could be not the slightest chance of discovery by a mobile monitoring unit.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He placed his hand on the key. He was surprised to realize his palm was slightly clammy. It would be his first direct transmission to Milton Hall.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He began to tap the key.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("First, three letters, RMH, the call letters, which stood for Roberts Milton Hall. Three times. Then the group, QSP, which meant "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Accept my priority message,")]), _vm._v(" followed by his brief message: TEST ACKNOWLEDGE, which came out to exactly three groups of five letters when encoded. And finally his own call letters, his signature: TGG — "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("T")]), _vm._v("ed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("G")]), _vm._v("rand "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("G")]), _vm._v("uignol — and his security check, a special group of letters that if changed would tell the home station that the operative had been captured and was transmitting under duress.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("His fingers operated the key with quick, crisp motions. The transmission was completed in less than forty-five seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Now what?” Gaby asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We wait.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("No one spoke. Everyone was staring at the X-35.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Ted looked intense as he strained to listen to the faint static in his earphones.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The seconds ticked by.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A watched phone never rings, Gaby thought. I wonder if that holds true for a watched X-35? “How do we know they’re even listening?” Gaby whispered.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page105"
    }
  }), _c('a', {
    attrs: {
      "id": "page106"
    }
  })]), _c('a', {
    attrs: {
      "id": "page106"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Schedule of transmissions,” Etienne answered her under his breath. “Ted has certain hours when his contact in England will have an open set. He has —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Ted suddenly tensed. He bent over his writing pad. He wrote: QS5 — QS5 — QS5.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He looked up at the others, a broad grin on his face. “We’re in!” he said. “Good job, Etienne.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“QS5?” Gaby asked. “What does it mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It means "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("We read you loud and clear,”")]), _vm._v(" Etienne said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Ted was writing more letters on his pad. Then he sent a brief sign-off and closed down the set. He looked up at the others.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We go,” he said. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“D")]), _vm._v(" has given his blessing!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Who the hell is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("D?”")]), _vm._v(" Mike asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Code name for the Chief of SOE,” Ted told him. “The Big Cheese himself.” He stood up. “Okay,” he said resolutely. “As you theater types say, ‘Let’s get the show on the road!’ “")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("Thirty minutes later the four members of Special Jedburgh Team Grand Guignol had changed from their own clothes into those they would wear during their journey to Misdroy, supplied by Etienne’s Resistance group.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gaby adjusted her white cap with the Red Cross insignia on her head. Instinctively, she tried to make it look attractive, but her fetchy Parisian chic had effectively been replaced with the practical look of a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Krankenschwester")]), _vm._v(" — a German nurse — in her light-blue, long-sleeved dress and big white apron.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("She looked at her “patient.” In his military hospital gown and robe, his bare feet stuck into brown ersatz leather slippers, Mike looked awkward and uncomfortable.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Ted, she decided, looked most the part, trim in the uniform of an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Unterarzt")]), _vm._v(" — a Master Sergeant doctor — with Kevin a close second, wearing the uniform of an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Obergefreiter")]), _vm._v(" in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sanitätsdienst")]), _vm._v(" — a corporal in the German Medical Corps.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page106"
    }
  }, [_vm._v("Enemy uniforms all, she thought, with a pang of discomfort. She felt on edge. And the irrefutable knowledge")]), _c('a', {
    attrs: {
      "id": "page107"
    }
  }, [_vm._v(" (which had remained unspoken by them all but lurked behind every word) that their unmasking would mean certain and unpleasant death did nothing to alleviate her apprehension.")])]), _c('a', {
    attrs: {
      "id": "page107"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Etienne, who somehow had assumed the role of local control for the team, held up his hand. “One last check,” he said. “First, your papers. Your personal identification papers? Your tags? Your "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Soldbuch?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin felt for the military record book all German soldiers carried. It was there in his pocket. Automatically, they all checked. They nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Your ID for later is packed with your clothing,” Etienne went on. “Now your travel papers. Permits? Special orders? Driver’s license? Medical papers? Special authorizations?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin flipped the papers on his clipboard. All there. He was again impressed with the super job Etienne’s men had done — in record time. Forged from the documents they’d photographed, the papers all looked completely authentic, down to the signature of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generalstabsarzt")]), _vm._v(" Rietkoff, found on some of them. Even someone who might know the general’s signature (and there weren’t apt to be too many who did) would accept the forgery as being genuine. And several of the special permits, designed to get them out of the city as expediently as possible, were signed with a perfectly forged signature of General Hans von Boineburg-Lengsfeld, Commandant of Greater Paris. Couldn’t be more official than that. As Etienne had said, a faked document must be more real than a real one.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Now,” Etienne continued, “once more. You are transporting a special high-ranking patient, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generalarzt")]), _vm._v(" Ludwig Bauernweiss, an Army Corps Chief Medical Officer, from Ortslazarett Clamart, a military hospital in the southwest outskirts of Paris, to a general military hospital in Berlin. Your patient is —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He was interrupted by a young man who came bursting into the room.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It is here!” he shouted excitedly. “It is just outside.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Très bien,” Etienne said. We shall look it over.”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page107"
    }
  }), _c('a', {
    attrs: {
      "id": "page108"
    }
  })]), _c('a', {
    attrs: {
      "id": "page108"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("He strode to the door. The others followed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The field ambulance was parked in the alley outside. It was a regular German military ambulance, marked with large Red Cross emblems on the sides, but a prominent sign had been stenciled on the back doors:")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("WARNUNG!")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("QUARANTÄNE")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ansteckende Krankheit")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ZUTRITT VERBOTEN!")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("WARNING!")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_vm._v("QUARANTINE")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_vm._v("Contagious Disease")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_vm._v("DO NOT ENTER!")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Kevin went up and peered through the windows in the doors into the interior of the ambulance. There was a cot and a chair, both fastened to the walls; a small shelf-table, also attached to the side of the vehicle, with a few medicine bottles and sanitary gear, a metal container of drinking water with a screw-on top and two mugs; and a medicine cabinet with two doors, set into the space under the isolated driver’s cab. In the ceiling, the rim of a filtered ventilation fan could be seen, and two large sealed metal containers marked CONTAMINATED WASTE — HANDLE WITH EXTREME CARE were clamped with steel bands to one wall. That’s where the X-35, Ted’s gun, and our clothing are stored, he thought. Not bad.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The license plates have been altered since we stole the vehicle last night,” Etienne told them. “So you should have no trouble getting out of Paris, yes? Not with your papers.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He looked gravely at them.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Goodbye, mes amis,” he said. “Et bonne chance!” He nodded toward the ambulance. “The thing runs on real gasoline,” he said. “Your papers will allow you to fill your tank at any military depot.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Solemnly they all embraced.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page108"
    }
  }), _c('a', {
    attrs: {
      "id": "page109"
    }
  })]), _c('a', {
    attrs: {
      "id": "page109"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("One by one they entered the ambulance. Mike and Gaby in the back, Kevin behind the wheel.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Ted gazed at the ambulance. Labeled and packed, he thought. A remembered report suddenly bubbled to the surface of his mind, a report about the clandestine German military operations prior to 1933, forbidden by the Versailles Treaty that ended World War I. Contrary to agreement, the Germans had trained military personnel in tank and air warfare on secret bases in Russia — and shipped the bodies of young men accidentally killed during the exercises back to Germany in wooden crates marked MACHINE PARTS. Labeled and packed . . . Labeled and packed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("At least he and his fellow team members were alive, he thought.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("For now.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Etienne put his hand on his shoulder and held him back for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“My friend,” he said soberly, “a final word. Remember. If you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" caught, do not be afraid to betray us. We shall have moved from the cave. Within the next few hours. But we shall leave enough evidence so the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Boche")]), _vm._v(" will know you have spoken the truth.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“But —”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No, mon ami,” Etienne interrupted him. “Do not protest. The Germans, they can make the walls talk. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("When Lieutenant Colonel Ramsey hurriedly entered the office of Brigadier Parnell in the main building of Milton Hall, Colonel Baldon, Lieutenant Colonel Lamont, and Major Roberts were already there with the CO.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I apologize for being late, sir,” Ramsey said. “But I was in the field with a demolition exercise when I got the word.”")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page109"
    }
  }, [_vm._v("Parnell waved at an empty chair. “Have a seat, Cliff,” he said. “Roberts has had a signal from that Resistance chap in Paris. Gerard. Relayed from London. We are discussing it.” He handed Ramsey a sheet of paper. “Read it,” he said. “A bit of a grue, actually. It outlines the entire plan Grand")]), _c('a', {
    attrs: {
      "id": "page110"
    }
  }, [_vm._v(" Guignol has underway in order to get them to Misdroy as quickly as possible.”")])]), _c('a', {
    attrs: {
      "id": "page110"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Ramsey read the decoded message. He looked up.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Imaginative buggers, aren’t they?” he commented.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“A bit — theatrical, I should say, what?” the brigadier said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Right up the Grand Guignol alley, I’d say,” Baldon grinned. “Horrible contagious disease and all.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Ah, yes,” the CO said. He frowned. He turned to Ramsey. “If the team does reach Misdroy,” he said, “is their local contact reliable? Kepper, is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Keppler, sir,” Ramsey said. “Janusz Keppler.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Capital. They cannot just arrive blind, what? Who is this Keppler?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Ramsey looked uncomfortable. “The man is a canal barge captain in the area,” he said. “He is of Polish descent.” He hesitated. “We — we haven’t actually a great deal of knowledge about his current activities. But several years ago he was of help to one of our agents, Jeff, on the Enigma matter. After that we placed him as a sleeper.” He looked at the brigadier. “We haven’t actually been in touch with him since that time. All we know is, he is still in the area.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“That’s pretty damned thin,” Baldon said. “The Enigma Machine caper, for crissake! That’s almost five years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It is the best we can do,” Ramsey said stiffly.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Do better!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You have a suggestion, Dirk?” Ramsey looked archly at his OSS counterpart. “Keppler is a sleeper. We can reestablish contact with him only directly. Someone must go there in person to see him. That someone may as well be Grand Guignol.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“So, in essence, they "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" going in blind,” Baldon said heatedly. “Or worse. That Keppler guy may have had a change of heart for all you know. He may work for the damned Nazis now. How can you be sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We can’t. But there is no reason to believe that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And Grand Guignol. Do they know how — how dicey, as you say, their contact is?”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page110"
    }
  }), _c('a', {
    attrs: {
      "id": "page111"
    }
  })]), _c('a', {
    attrs: {
      "id": "page111"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Ted knows,” Ramsey said. “I do not know if he has informed his teammates.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“They don’t have much of a chance to pull it off, do they?” Dirk said bitterly. “We’d better bloody well cross our fingers on this one.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Parnell nodded slowly. “It was a difficult decision to make,” he said, “sending in Grand Guignol. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("D")]), _vm._v(" is skeptical of the operation, too, but for different reasons. He unfortunately considers Grand Guignol a lame effort. Three of the four are completely without training, he pointed out. One is a girl, and one is a cripple. Missing one arm, I’m told. Not much of a match for the combined German counterintelligence forces, what?” He sighed. “But, of course, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("D")]), _vm._v(" realizes, as do we, that the situation at Mimoyecques is serious enough to try anything. Take any chances.” He turned to Lieutenant Colonel Lamont. “What is the latest intelligence, Colonel?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Nothing really new, sir,” Lamont answered. “There is considerably increased activities at the site. Enemy security has been beefed up even more, and the Fifteenth Army is still in place. Local sources indicate that more than five thousand forced laborers are now working around the clock.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“On what, dammit? On "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("what?”")]), _vm._v(" Baldon exclaimed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Lamont shrugged. “We do not know,” he confessed. “All we know is that more and more workers are arriving almost every day.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Baldon turned to Ramsey. “What about your Brylcreem Boys?” he asked. “Anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Ramsey shook his head. “Air Intelligence has no information.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Then Misdroy is not just our best bet,” Baldon said, “it is our only bet.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The CO looked grim. “Perhaps,” he said. “I hope we are not on a losing wicket with Grand Guignol. But just in case we should be, I want a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("real")]), _vm._v(" Jedburgh team readied and briefed to try to infiltrate Mimoyecques once more.” He turned to Major Roberts. “Get on it at once.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes, sir,” Roberts said.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page111"
    }
  }), _c('a', {
    attrs: {
      "id": "page112"
    }
  })]), _c('a', {
    attrs: {
      "id": "page112"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("Parnell turned to the others.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We cannot afford to place our total reliance on three actors, inexperienced in intelligence-gathering, and one Jed, who I understand is a bit of an, ah, inconsistent chap.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He stood up. The meeting was at an end.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We can only hope for the best,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But there was little conviction in his voice. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "marg"
  }, [_vm._v("They had just left Forbach, where they had filled the tank of the ambulance at a border patrol depot. They’d been on the road for five and a half hours and it was late afternoon. The road sign read: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("SAARBRÜCKEN 9 Km.")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Nine kilometers to Germany.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The trip had been uneventful so far. Their first and only scare had come almost immediately after they’d left the alley and started to drive through Paris. At Place de la Republic they had been stopped at a roving checkpoint. But the Feldwebel in charge had only wanted to be helpful. He gave them a motorcycle escort, who piloted them through town, clearing the way for them, and taking them all the way to Noisy on the outskirts of the city, all the way to the main military route over Chalons sur Marne to the German border at the coal mining town of Saarbrücken.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Signs directing traffic to the border checkpoint led them through the old, sometimes French, sometimes German city, which showed the ugly scars of the heavy shelling in 1939 and the later destructive air strikes.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The Grand Guignol team had chosen to enter Germany here at the most conspicuous place and go on to Berlin over Mainz and Frankfurt, Erfurt and Halle. They’d taken the same route, Kevin thought idly, that Napoleon had chosen on his march from Paris to Mainz. Saarbrücken had then been an armament center. Now it was an important checkpoint on the German military route from Paris to Berlin.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("A sign at the roadside warned: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("GRENZSTELLE 500m —")]), _vm._v(" BORDERSTATION 500 meters.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("At a huge sign with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("HALT!")]), _vm._v(" stenciled in black block letters,")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page112"
    }
  }), _c('a', {
    attrs: {
      "id": "page113"
    }
  })]), _c('a', {
    attrs: {
      "id": "page113"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("a border guard waved them to one side. Slowly they drove to the indicated spot and stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Two bored guards came up to Kevin, both of them carrying Schmeisser submachine guns at port arms.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Papiere herzeigen! —")]), _vm._v(" show your papers!” one of them ordered. Kevin gave him his clipboard. The guard rifled through the documents. He frowned at them and examined them more closely. He walked to the rear of the ambulance and looked in through the windows, then he came back to Kevin.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Wait here,” he instructed.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He strode to a small building and entered. Kevin and Ted exchanged glances, both desperately trying not to look worried.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("But they were. What was wrong?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Nice day,” Kevin said pleasantly to the guard who had remained behind.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The man merely grunted.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Presently the first guard reemerged from the building, followed by a Waffen SS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Obersturmführer,")]), _vm._v(" who held Kevin’s clipboard in his hands. The two men marched up to Ted.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Unterarzt")]), _vm._v(" Dornhoffer?” the officer asked brusquely.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Ted nodded pleasantly. “I am, Lieutenant,” he said. “What seems to be the problem?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The officer nodded at the ambulance. “Your "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Krankenwagen,”")]), _vm._v(" he said. “Your ambulance. The guards have orders to inspect all vehicles. You will have to open the doors.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Ted stared at the officer. Slowly he shook his head. “I — I regret, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Herr Obersturmführer,”")]), _vm._v(" he said, obviously ill at ease. “But I cannot do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The officer glared at him. “It is an order — "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sergeant!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The doors are open, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Herr Obersturmführer,”")]), _vm._v(" Ted said. “They are not locked. It is — it is just that I — I myself do not want to — to open them. You, of course, may do so.”")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page113"
    }
  }, [_vm._v("“You are insufferably insolent, Sergeant,” the officer")]), _c('a', {
    attrs: {
      "id": "page114"
    }
  }, [_vm._v(" growled angrily. “And you will be reported.” He turned on his heel and started for the rear of the ambulance. Ted called after him.")])]), _c('a', {
    attrs: {
      "id": "page114"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“One moment, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Herr Obsersturmführer")]), _vm._v("!” He climbed from the cab and joined the officer at the rear of the ambulance.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“With the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Herr Obersturmführer’s")]), _vm._v(" permission,” he said subserviently, “may I have the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Herr Obersturmführer’s")]), _vm._v(" name and serial number?” He held a pencil poised over a small notebook.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The officer was momentarily taken aback. “Why?” he snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I beg the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Herr Obersturmführer’s")]), _vm._v(" pardon,” Ted said. “But I am under orders to report anyone who enters this quarantined ambulance. It is so "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("they")]), _vm._v(" can be quarantined if necessary. It is so they will not infect others. I am sure the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Herr Obersturmführer")]), _vm._v(" understands.” He held his pencil ready over the booklet. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Bitte?”")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The officer stared at Ted. He said nothing. Ted fished a cotton face mask from his pocket. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Bitte,”")]), _vm._v(" he said solicitously. “Please. If the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Herr Obersturmführer")]), _vm._v(" will wear this, it may afford "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("some")]), _vm._v(" protection. And may I respectfully caution the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Herr Obersturmführer")]), _vm._v(" to be most careful in touching anything inside.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The officer turned to the ambulance and peered through the windows in the doors. On the cot inside he saw Mike lying on his back, his eyes closed, his face covered with large red weeping sores. He stirred fitfully. Gaby, wearing a face mask, was gently bathing his feverish forehead.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“The general caught the disease in Africa,” Ted said in the half-whisper of awe. “It is a form of virulent leprosy, they believe. Only in Berlin may they know how to treat it. That is why the Chief Medical Officer of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generalfeldmarschall")]), _vm._v(" von Rundtedt’s Army Group himself is anxious to get him there without delay. The patient is a personal friend.”")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page114"
    }
  }, [_vm._v("He held up the face mask. “May I help the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Herr Obersturmführer")]), _vm._v(" with this,” he asked politely. “And I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("will")])]), _c('a', {
    attrs: {
      "id": "page115"
    }
  }, [_vm._v(" need the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Herr Obersturmführer’s")]), _vm._v(" identification information,” he added apologetically.")])]), _c('a', {
    attrs: {
      "id": "page115"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("The officer brushed him away.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Ted backed off.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“With the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Herr Obersturmführer’s")]), _vm._v(" permission,” he said. “I will wait in the cab while the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Herr Obersturmführer")]), _vm._v(" makes his inspection of the ambulance.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The officer turned to him. He slammed the clipboard into Ted’s chest.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Zum Teufel damit!")]), _vm._v(" — To the devil with it!” he barked. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Los!")]), _vm._v(" — Be on your way!”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Jawohl, Herr Obersturmführer,”")]), _vm._v(" Ted cried smartly. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Sofort, Herr Obersturmführer")]), _vm._v("! — At once!")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He hurried back to the cab. Kevin quickly started the engine, and they drove off. A few minutes later they left the town of Saarbrücken and tooled along the road toward Mainz. The mission of Special Jedburgh Team Grand Guignol had just begun. Ahead of them lay challenges and dangers unknown to them all. And the enigma of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tausendfüssler.")]), _vm._v(" . . .")])])]), _c('a', {
    attrs: {
      "id": "page115"
    }
  })]), _c('a', {
    attrs: {
      "id": "page115"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-384c97aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Part_01.vue
// module id = 90
// module chunks = 0